webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(512),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(54);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(56);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HALSONResource, createHALSONResource;

HALSONResource = function HALSONResource(data) {
  var _embedded, attr, self;
  data = data || {};
  if (typeof data === 'string') {
    data = JSON.parse(data);
  }
  for (attr in data) {
    if (!(attr in this) && data.hasOwnProperty(attr)) {
      _vue2.default.set(this, attr, data[attr]);
    }
  }
  // @[attr] = data[attr]
  if (this._embedded && (0, _typeof3.default)(this._embedded) === 'object') {
    _embedded = {};
    self = this;
    (0, _keys2.default)(this._embedded).forEach(function (key) {
      if (self._embedded.hasOwnProperty(key)) {
        _embedded[key] = [].concat(self._embedded[key]).map(function (embed) {
          return createHALSONResource(embed);
        });
      }
    });
    _vue2.default.set(this, '_embedded', _embedded);
  }
  this._compact('_embedded');
  this._compact('_links');
};

createHALSONResource = function createHALSONResource(data) {
  if (data && data.className === HALSONResource.prototype.className) {
    return data;
  }
  return new HALSONResource(data);
};

HALSONResource.prototype._compact = function (name, key) {
  var keys, target;
  target = this[name];
  if ((typeof target === 'undefined' ? 'undefined' : (0, _typeof3.default)(target)) !== 'object') {
    return;
  }
  keys = key ? [key] : (0, _keys2.default)(target);
  keys.forEach(function (k) {
    var items;
    items = target[k];
    if (!Array.isArray(items)) {
      return;
    }
    if (!items.length) {
      delete target[k];
    } else if (items.length === 1) {
      target[k] = items[0];
    }
  });
  if (!(0, _keys2.default)(target).length) {
    return delete this[name];
  }
  _vue2.default.set(this, name, target);
};

// @[name] = target
HALSONResource.prototype.className = 'HALSONResource';

HALSONResource.prototype._invert = function (filterCallback) {
  return function () {
    return !filterCallback.apply(null, arguments);
  };
};

HALSONResource.prototype.listLinkRels = function () {
  if (this._links) {
    return (0, _keys2.default)(this._links);
  } else {
    return [];
  }
};

HALSONResource.prototype.listEmbedRels = function () {
  if (this._embedded) {
    return (0, _keys2.default)(this._embedded);
  } else {
    return [];
  }
};

HALSONResource.prototype.getLinks = function (rel, filterCallback, begin, end) {
  var links;
  if (!this._links || !(rel in this._links)) {
    return [];
  }
  links = [].concat(this._links[rel]);
  if (filterCallback) {
    links = links.filter(filterCallback);
  }
  return links.slice(begin || 0, end || links.length);
};

HALSONResource.prototype.getLink = function (rel, filterCallback, def) {
  if (typeof filterCallback !== 'function') {
    def = filterCallback;
    filterCallback = null;
  }
  return this.getLinks(rel, filterCallback, 0, 1)[0] || def;
};

HALSONResource.prototype.getEmbeds = function (rel, filterCallback, begin, end) {
  var items;
  if (!this._embedded || !(rel in this._embedded)) {
    return [];
  }
  items = [].concat(this._embedded[rel]);
  if (filterCallback) {
    items = items.filter(filterCallback);
  }
  return items.slice(begin || 0, end || items.length);
};

HALSONResource.prototype.getEmbed = function (rel, filterCallback, def) {
  if (typeof filterCallback !== 'function') {
    def = filterCallback;
    filterCallback = null;
  }
  return this.getEmbeds(rel, filterCallback, 0, 1)[0] || def;
};

HALSONResource.prototype.getEmbedByRelAndUID = function (rel, uid) {
  return this.getEmbed(rel, function (embed) {
    return embed.uid === uid;
  });
};

HALSONResource.prototype.addLink = function (rel, link) {
  if (typeof link === 'string') {
    link = {
      href: link
    };
  }
  if (!this._links) {
    _vue2.default.set(this, '_links', {});
  }
  if (!(rel in this._links)) {
    // single link
    _vue2.default.set(this._links, rel, link);
  } else {
    // multiple links
    // @_links[rel] = link
    this._links[rel] = [].concat(this._links[rel]);
    this._links[rel].push(link);
  }
  return this;
};

HALSONResource.prototype.addEmbed = function (rel, embed) {
  return this.insertEmbed(rel, -1, embed);
};

HALSONResource.prototype.insertEmbed = function (rel, index, embed) {
  var items, params;
  if (!this._embedded) {
    _vue2.default.set(this, '_embedded', {});
  }
  if (!(rel in this._embedded)) {
    _vue2.default.set(this._embedded, rel, Array.isArray(embed) ? embed.map(createHALSONResource) : createHALSONResource(embed));
    return this;
  }
  items = [].concat(embed).map(createHALSONResource);
  _vue2.default.set(this._embedded, rel, [].concat(this._embedded[rel]));
  if (index < 0) {
    Array.prototype.push.apply(this._embedded[rel], items);
  } else {
    params = [index, 0].concat(items);
    Array.prototype.splice.apply(this._embedded[rel], params);
  }
  this._compact('_embedded', rel);
  return this;
};

HALSONResource.prototype.removeLinks = function (rel, filterCallback) {
  if (!this._links || !(rel in this._links)) {
    return;
  }
  if (!filterCallback) {
    delete this._links[rel];
  } else {
    this._links[rel] = [].concat(this._links[rel]).filter(this._invert(filterCallback));
  }
  this._compact('_links', rel);
  return this;
};

HALSONResource.prototype.removeEmbeds = function (rel, filterCallback) {
  if (!this._embedded || !(rel in this._embedded)) {
    return;
  }
  if (!filterCallback) {
    return delete this._embedded[rel];
  }
  this._embedded[rel] = [].concat(this._embedded[rel]).filter(this._invert(filterCallback));
  this._compact('_embedded', rel);
  return this;
};

HALSONResource.prototype.removeEmbedByRelAndUID = function (rel, uid) {
  this.removeEmbeds(rel, function (embed) {
    return embed.uid === uid;
  });
  return this;
};

createHALSONResource.Resource = HALSONResource;

exports.default = createHALSONResource;

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(28);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(29);

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _HALSONResource = __webpack_require__(37);

var _HALSONResource2 = _interopRequireDefault(_HALSONResource);

var _v = __webpack_require__(467);

var _v2 = _interopRequireDefault(_v);

var _Wsse = __webpack_require__(294);

var _Wsse2 = _interopRequireDefault(_Wsse);

var _axios = __webpack_require__(339);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XHR,
    hasProp = {}.hasOwnProperty;

// axios.defaults.baseURL = 'http://localhost:8777'
_axios2.default.defaults.baseURL = "/";

// user = 'hansw'
// passwd = 'defccb4b0b49d5c3ccaf952f926397a2b53685ab7de86ca242b0010e5877d56dade0c45bb73ab7b0ed235ec60002f60b60d7817c27a3dfb98adf270c08c3a2ea'
XHR = function () {
  function XHR() {
    (0, _classCallCheck3.default)(this, XHR);

    this.auth_interceptor = null;
  }

  (0, _createClass3.default)(XHR, [{
    key: 'stripSlash',
    value: function stripSlash(url) {
      return url.replace(/^\//g, '');
    }
  }, {
    key: 'filter',
    value: function filter(obj) {
      var key, result, value;
      result = {};
      for (key in obj) {
        if (!hasProp.call(obj, key)) continue;
        value = obj[key];
        if (key.charAt(0) !== '_') {
          result[key] = value;
        }
      }
      return result;
    }
  }, {
    key: 'setUser',
    value: function setUser(user, passwd) {
      if (this.auth_interceptor != null) {
        _axios2.default.interceptors.request.eject(this.auth_interceptor);
      }
      return this.auth_interceptor = _axios2.default.interceptors.request.use(function (config) {
        config.headers.common['X-WSSE'] = _Wsse2.default.wsseHeader(user, passwd);
        return config;
      });
    }
  }, {
    key: 'get',
    value: function get(url, params) {
      url = this.stripSlash(url);
      console.log('get: ', url);
      return _axios2.default.get(url, {
        params: params
      }).then(function (response) {
        return (0, _HALSONResource2.default)(response.data);
      });
    }
  }, {
    key: 'put',
    value: function put(item) {
      var url;
      url = this.stripSlash(item.getLink('self').href);
      console.log('put: ', url, item);
      return _axios2.default.put(url, this.filter(item)).then(function (response) {
        return (0, _HALSONResource2.default)(response.data);
      });
    }
  }, {
    key: 'post',
    value: function post(url, item) {
      url = this.stripSlash(url);
      // item.uid = uuid() if not item.uuid?
      console.log('post: ', url, item);
      return _axios2.default.post(url, this.filter(item)).then(function (response) {
        return (0, _HALSONResource2.default)(response.data);
      });
    }
  }, {
    key: 'delete',
    value: function _delete(item) {
      var url;
      url = this.stripSlash(item.getLink('self').href);
      console.log('delete: ', url, item);
      return _axios2.default.delete(url).then(function (response) {
        return response.data;
      });
    }
  }]);
  return XHR;
}();

exports.default = XHR;

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(500),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05c41db0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(521),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(324)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueRouter = __webpack_require__(469);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _Activities = __webpack_require__(493);

var _Activities2 = _interopRequireDefault(_Activities);

var _Administration = __webpack_require__(494);

var _Administration2 = _interopRequireDefault(_Administration);

var _ClientForm = __webpack_require__(495);

var _ClientForm2 = _interopRequireDefault(_ClientForm);

var _Content = __webpack_require__(496);

var _Content2 = _interopRequireDefault(_Content);

var _Login = __webpack_require__(497);

var _Login2 = _interopRequireDefault(_Login);

var _Statistics = __webpack_require__(498);

var _Statistics2 = _interopRequireDefault(_Statistics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    component: _Login2.default,
    name: 'Login',
    path: '/login'
  }, {
    component: _Content2.default,
    name: 'Content',
    path: '/',
    children: [{
      component: _ClientForm2.default,
      name: 'Start',
      path: 'start'
    }, {
      component: _Activities2.default,
      name: 'Activities',
      path: 'activities'
    }, {
      component: _Administration2.default,
      name: 'Administration',
      path: 'administration'
    }, {
      component: _Statistics2.default,
      name: 'Statistics',
      path: 'statistics'
    }]
  }]
});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(3);

var _vuex2 = _interopRequireDefault(_vuex);

var _state = __webpack_require__(298);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(295);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(297);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(296);

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: _state2.default,
  mutations: _mutations2.default,
  actions: _actions2.default,
  getters: _getters2.default,
  strict: "production" !== 'production'
});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray2 = __webpack_require__(55);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  after: function after(field, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
        target = _ref2[0];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara efter ' + target + '.';
  },
  alpha_dash: function alpha_dash(field) {
    return 'F\xE4ltet "' + field + '" kan inneh\xE5lla alfa-numeriska tecken s\xE5v\xE4l som snedstreck och understreck.';
  },
  alpha_num: function alpha_num(field) {
    return 'F\xE4ltet "' + field + '" f\xE5r bara inneh\xE5lla alfa-numeriska tecken.';
  },
  alpha_spaces: function alpha_spaces(field) {
    return 'F\xE4ltet "' + field + '" f\xE5r bara inneh\xE5lla alfabetiska tecken och mellanslag.';
  },
  alpha: function alpha(field) {
    return 'F\xE4ltet "' + field + '" f\xE5r bara inneh\xE5lla alfabetiska tecken.';
  },
  before: function before(field, _ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
        target = _ref4[0];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara tidigare \xE4n ' + target + '.';
  },
  between: function between(field, _ref5) {
    var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
        min = _ref6[0],
        max = _ref6[1];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara mellan ' + min + ' och ' + max + '.';
  },
  confirmed: function confirmed(field, _ref7) {
    var _ref8 = (0, _slicedToArray3.default)(_ref7, 1),
        confirmedField = _ref8[0];

    return 'F\xE4ltet "' + field + '" matchar inte ' + confirmedField + '.';
  },
  date_between: function date_between(field, _ref9) {
    var _ref10 = (0, _slicedToArray3.default)(_ref9, 2),
        min = _ref10[0],
        max = _ref10[1];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara mellan ' + min + ' och ' + max + '.';
  },
  date_format: function date_format(field, _ref11) {
    var _ref12 = (0, _slicedToArray3.default)(_ref11, 1),
        format = _ref12[0];

    return 'F\xE4ltet "' + field + '" m\xE5ste ha formatatet ' + format + '.';
  },
  decimal: function decimal(field) {
    var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['*'],
        _ref14 = (0, _slicedToArray3.default)(_ref13, 1),
        decimals = _ref14[0];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara numeriskt och f\xE5r inneh\xE5lla ' + (decimals === '*' ? '' : decimals) + ' decimaltecken.';
  },
  digits: function digits(field, _ref15) {
    var _ref16 = (0, _slicedToArray3.default)(_ref15, 1),
        length = _ref16[0];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara numeriskt och inneh\xE5lla exakt' + length + ' siffor.';
  },
  dimensions: function dimensions(field, _ref17) {
    var _ref18 = (0, _slicedToArray3.default)(_ref17, 2),
        width = _ref18[0],
        height = _ref18[1];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara ' + width + ' pixlar bred och ' + height + ' pixlar h\xF6g.';
  },
  email: function email(field) {
    return 'The "' + field + '" must be a valid email.';
  },
  ext: function ext(field) {
    return 'F\xE4ltet "' + field + '" m\xE5ste vara en godk\xE4d fil.';
  },
  image: function image(field) {
    return 'F\xE4ltet "' + field + '" m\xE5ste vara en bildfil.';
  },
  in: function _in(field) {
    return 'F\xE4ltet "' + field + '" m\xE5ste vara ett godk\xE4nt alternativ';
  },
  ip: function ip(field) {
    return 'F\xE4ltet "' + field + '" m\xE5ste vara en godk\xE4nd ip-adress.';
  },
  max: function max(field, _ref19) {
    var _ref20 = (0, _slicedToArray3.default)(_ref19, 1),
        length = _ref20[0];

    return 'F\xE4ltet "' + field + '" f\xE5r inte vara l\xE4ngre \xE4n ' + length + ' tecken.';
  },
  mimes: function mimes(field) {
    return 'F\xE4ltet "' + field + '" m\xE5ste ha en fil\xE4ndelse.';
  },
  min: function min(field, _ref21) {
    var _ref22 = (0, _slicedToArray3.default)(_ref21, 1),
        length = _ref22[0];

    return 'F\xE4ltet "' + field + '" m\xE5ste minst vara ' + length + ' tecken.';
  },
  not_in: function not_in(field) {
    return 'F\xE4ltet "' + field + '" m\xE5ste vara ett godk\xE4nt alternativ ';
  },
  numeric: function numeric(field) {
    return 'F\xE4ltet "' + field + '" f\xE5r bara inneh\xE5lla numeriska tecken.';
  },
  regex: function regex(field) {
    return 'F\xE4ltet "' + field + '" har en felaktig formatering.';
  },
  required: function required(field) {
    return 'F\xE4ltet "' + field + '" \xE4r obligatoriskt.';
  },
  size: function size(field, _ref23) {
    var _ref24 = (0, _slicedToArray3.default)(_ref23, 1),
        _size = _ref24[0];

    return 'F\xE4ltet "' + field + '" m\xE5ste vara mindre \xE4n' + _size + ' KB.';
  },
  url: function url(field) {
    return 'F\xE4ltet "' + field + '" \xE4r inte en godk\xE4nd URL.';
  }
};

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Snackbar = __webpack_require__(487);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'App',
  components: {
    'v-snackbar': _Snackbar2.default
  },
  data: function data() {
    return {
      message: null
    };
  },
  methods: {
    showMessage: function showMessage(msg) {
      var _this = this;

      this.message = msg;
      return setTimeout(function () {
        return _this.message = null;
      }, 1000);
    }
  },
  mounted: function mounted() {
    if (this.$store.state.user.is_logged_in) {
      this.$store.dispatch('refresh_login', this.$store.state.user);
    }
    return this.$store.dispatch('getServices');
  }
};

// updated: ->
// 	@$nextTick ->
// 		componentHandler.upgradeElements @$el

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _IconToggleButton = __webpack_require__(76);

var _IconToggleButton2 = _interopRequireDefault(_IconToggleButton);

var _Switch = __webpack_require__(492);

var _Switch2 = _interopRequireDefault(_Switch);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(3);

var _vueClickaway = __webpack_require__(468);

var clickAway = _interopRequireWildcard(_vueClickaway);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ClientList',
  components: {
    'v-icon-toggle-button': _IconToggleButton2.default
  },
  directives: {
    'onClickaway': clickAway.directive
  },
  data: function data() {
    return {
      is_active: false,
      filter_active: true,
      show_year: null,
      show_dropdown: false
    };
  },
  mounted: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.are_loaded.resources) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.$store.dispatch('getServices');

            case 3:
              if (this.are_loaded.client_list) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return this.$store.dispatch('getClientList');

            case 6:
              return _context.abrupt('return', _context.sent);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    select: function select(client) {
      return this.$store.dispatch('selectClient', client);
    },
    clickYear: function clickYear(year) {
      if (this.show_year !== year) {
        return this.show_year = year;
      } else {
        return this.show_year = null;
      }
    },
    away: function away() {
      return this.show_dropdown = false;
    }
  },
  computed: (0, _vuex.mapState)({
    client_list: function client_list(state) {
      return _lodash2.default.orderBy(state.client_list.getEmbeds('clients'), ['id']);
    },
    selected_client: function selected_client(state) {
      return state.selected_client;
    },
    resources: function resources(state) {
      return state.resources;
    },
    unactive_list: function unactive_list() {
      var list, new_list;
      list = this.client_list.filter(function (item) {
        return item.end != null;
      });
      console.log('list: ', list);
      new_list = _lodash2.default.groupBy(list, function (item) {
        return item.end.slice(0, 4);
      });
      console.log('new_list: ', new_list);
      return new_list;
    },
    active_list: function active_list() {
      return this.client_list.filter(function (item) {
        return item.end === null || item.end === '';
      });
    },
    are_loaded: function are_loaded(state) {
      return state.are_loaded;
    }
  })
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__(3);

exports.default = {
  name: 'MenuDrawer',
  methods: {
    logout: function logout() {
      this.$store.dispatch('logout');
      return this.$router.push('/login');
    }
  },
  computed: (0, _vuex.mapState)({
    user: function user(state) {
      return state.user;
    }
  })
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(54);

var _keys2 = _interopRequireDefault(_keys);

var _html5sortable = __webpack_require__(446);

var _html5sortable2 = _interopRequireDefault(_html5sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  componentUpdated: function componentUpdated(el, bind) {
    var onUpdate, options, sortUpdate, sortable;
    // console.log 
    //   el: el
    //   bind: bind
    // Callback to execute on update
    onUpdate = bind.value;
    options = {
      items: (0, _keys2.default)(bind.modifiers)[0],
      handle: '.my-handle',
      forcePlaceholderSize: true
    };
    sortUpdate = function sortUpdate(e) {
      var err;
      console.log('e.detail: ', e.detail);
      try {
        return onUpdate(e.detail.newStartList, e.detail.item.dataset);
      } catch (error) {
        err = error;
        return console.log(err, e);
      }
    };
    sortable = (0, _html5sortable2.default)(el, options);
    return sortable[0].addEventListener('sortupdate', sortUpdate);
  }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tableexport = __webpack_require__(229);

var _tableexport2 = _interopRequireDefault(_tableexport);

var _TableDownloadButton = __webpack_require__(78);

var _TableDownloadButton2 = _interopRequireDefault(_TableDownloadButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'StatisticsTableFull',
  props: ['id', 'label', 'start', 'end', 'age_ranges', 'cluster'],
  components: {
    'download-button': _TableDownloadButton2.default
  },
  data: function data() {
    return {
      table: {}
    };
  },
  methods: {
    sumLengthByKey: function sumLengthByKey(arr, key) {
      var i, item, len, sum;
      sum = 0;
      for (i = 0, len = arr.length; i < len; i++) {
        item = arr[i];
        sum += (item[key] || []).length;
      }
      return sum;
    }
  },
  mounted: function mounted() {
    return this.table = this.$refs[this.label];
  }
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconToggleButton = __webpack_require__(76);

var _IconToggleButton2 = _interopRequireDefault(_IconToggleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ToggableOptionList',
  components: {
    'v-icon-toggle-button': _IconToggleButton2.default
  },
  data: function data() {
    return {
      show: false
    };
  },
  props: ['id', 'label', 'options']
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(25);

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

var _vuex = __webpack_require__(3);

var _Confirm = __webpack_require__(75);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _Sortable = __webpack_require__(74);

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setNewSortOrder,
    _extends = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

setNewSortOrder = function setNewSortOrder(collection, item, sortorder) {
  collection[item.dataset.order].sortorder = sortorder;
  return collection[item.dataset.order];
};

exports.default = {
  name: 'ActivitiesAdministration',
  data: function data() {
    return {
      edit_type: {
        name: null
      },
      edit_uid: null,
      new_type: {
        name: null
      },
      show: {
        confirm: false,
        message: '',
        action: null
      }
    };
  },
  components: {
    'v-dialog-confirm': _Confirm2.default
  },
  directives: {
    'sortable': _Sortable2.default
  },
  methods: {
    cancel: function cancel() {
      this.$store.dispatch('showDialog', null);
      return this.show.confirm = false;
    },
    addType: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.new_type.sortorder = this.activity_types.getEmbeds('activity_type').length;
                _context.next = 3;
                return this.$store.dispatch('addActivityType', this.new_type);

              case 3:
                return _context.abrupt('return', this.new_type.name = null);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addType() {
        return _ref.apply(this, arguments);
      }

      return addType;
    }(),
    deleteType: function deleteType(type) {
      var _this = this;

      this.show.message = 'Säker på att du vill radera "' + type.name + '"?';
      this.show.action = function () {
        return _this.removeType(type);
      };
      return this.$store.dispatch('showDialog', 'confirm');
    },
    removeType: function removeType(type) {
      this.$store.dispatch('deleteActivityType', type);
      this.$store.dispatch('showDialog', null);
      return this.show.confirm = false;
    },
    doEdit: function doEdit(type) {
      this.edit_uid = type.uid;
      return this.edit_type = _.cloneDeep(type);
    },
    updateType: function updateType(type, evt) {
      return this.$store.dispatch('updateActivityType', type);
    },
    reorderTypes: function reorderTypes(order) {
      return console.log('reorderTypes: ', order);
    }
  },
  // types = _.cloneDeep @activity_types.getEmbeds 'activity_type'

  // new_types = order.map (item, idx)->
  //   setNewSortOrder this, item, idx
  // , types

  // @$store.dispatch 'updateActivityTypes',
  //   types: new_types
  created: function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.are_loaded.resources) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return this.$store.dispatch('getServices');

            case 3:
              if (this.are_loaded.activity_types) {
                _context2.next = 7;
                break;
              }

              _context2.next = 6;
              return this.$store.dispatch('getActivityTypes');

            case 6:
              return _context2.abrupt('return', _context2.sent);

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _ref2.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    return componentHandler.downgradeElements(this.$el);
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isLoaded']), (0, _vuex.mapState)(['are_loaded', 'activity_types']))
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(25);

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _urlTemplate = __webpack_require__(50);

var _urlTemplate2 = _interopRequireDefault(_urlTemplate);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(3);

var _ClientList = __webpack_require__(232);

var _ClientList2 = _interopRequireDefault(_ClientList);

var _Confirm = __webpack_require__(75);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _IconToggleButton = __webpack_require__(76);

var _IconToggleButton2 = _interopRequireDefault(_IconToggleButton);

var _MiniFabButton = __webpack_require__(77);

var _MiniFabButton2 = _interopRequireDefault(_MiniFabButton);

var _OptionAdd = __webpack_require__(480);

var _OptionAdd2 = _interopRequireDefault(_OptionAdd);

var _OptionEdit = __webpack_require__(481);

var _OptionEdit2 = _interopRequireDefault(_OptionEdit);

var _PropertyAdd = __webpack_require__(482);

var _PropertyAdd2 = _interopRequireDefault(_PropertyAdd);

var _PropertyEdit = __webpack_require__(483);

var _PropertyEdit2 = _interopRequireDefault(_PropertyEdit);

var _PropertyGroupAdd = __webpack_require__(484);

var _PropertyGroupAdd2 = _interopRequireDefault(_PropertyGroupAdd);

var _PropertyGroupEdit = __webpack_require__(485);

var _PropertyGroupEdit2 = _interopRequireDefault(_PropertyGroupEdit);

var _RadioButton = __webpack_require__(36);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _Sortable = __webpack_require__(74);

var _Sortable2 = _interopRequireDefault(_Sortable);

var _Spinner = __webpack_require__(235);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _ToggableOptionList = __webpack_require__(475);

var _ToggableOptionList2 = _interopRequireDefault(_ToggableOptionList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setNewSortOrder,
    _extends = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

setNewSortOrder = function setNewSortOrder(collection, item, sortorder) {
  collection[item.dataset.order].sortorder = sortorder;
  return collection[item.dataset.order];
};

exports.default = {
  name: 'PropertiesAdministration',
  data: function data() {
    return {
      dialog: null,
      show: {
        confirm: false,
        message: '',
        action: null
      },
      toggle: {
        groups: {},
        options: {}
      },
      edit_group: {},
      add_to_group: {},
      edit_prop: {},
      edit_option: {},
      props_url_tmpl: null,
      debug: false,
      form: null,
      types: [{
        label: 'Nummer',
        value: 'NUMBER'
      }, {
        label: 'Sträng',
        value: 'STRING'
      }, {
        label: 'Ja/Nej',
        value: 'BOOLEAN'
      }, {
        label: 'Lista',
        value: 'ARRAY'
      }]
    };
  },
  components: {
    'v-dialog-property-group-edit': _PropertyGroupEdit2.default,
    'v-dialog-property-group-add': _PropertyGroupAdd2.default,
    'v-dialog-property-edit': _PropertyEdit2.default,
    'v-dialog-property-add': _PropertyAdd2.default,
    'v-dialog-option-add': _OptionAdd2.default,
    'v-dialog-option-edit': _OptionEdit2.default,
    'v-dialog-confirm': _Confirm2.default,
    'v-textfield': _Textfield2.default,
    'v-client-list': _ClientList2.default,
    'v-fab-button': _MiniFabButton2.default,
    'v-toggable-option-list': _ToggableOptionList2.default,
    'v-icon-toggle-button': _IconToggleButton2.default,
    'v-spinner': _Spinner2.default
  },
  directives: {
    'sortable': _Sortable2.default
  },
  methods: {
    //#####  DIALOGS
    addGroup: function addGroup() {
      return this.$store.dispatch('showDialog', 'add_group');
    },
    addProperty: function addProperty(group) {
      this.add_to_group = group;
      return this.$store.dispatch('showDialog', 'add_prop');
    },
    addOption: function addOption(group, prop) {
      this.edit_group = group;
      this.edit_prop = prop;
      return this.$store.dispatch('showDialog', 'add_option');
    },
    deleteGroup: function deleteGroup(group) {
      var _this = this;

      if (group.getEmbeds('client_property_definition').length === 0) {
        this.show.message = 'Säker på att du vill radera "' + group.name + '"?';
        this.show.action = function () {
          return _this.removeGroup(group);
        };
      } else {
        this.show.message = '"' + group.name + '" kan inte raderas - den innehåller egenskaper';
        console.log(group.getEmbeds('client_property_definition'));
        this.show.action = function () {
          return _this.cancel();
        };
      }
      return this.$store.dispatch('showDialog', 'confirm');
    },
    deleteProperty: function deleteProperty(prop) {
      var _this2 = this;

      this.show.message = 'Säker på att du vill radera "' + prop.label + '"?';
      this.show.action = function () {
        return _this2.removeProperty(prop);
      };
      return this.$store.dispatch('showDialog', 'confirm');
    },
    deleteOption: function deleteOption(group, prop, option) {
      var _this3 = this;

      this.show.message = 'Säker på att du vill radera "' + option.value + '"?';
      this.show.action = function () {
        return _this3.removeOption(option);
      };
      return this.$store.dispatch('showDialog', 'confirm');
    },
    editGroup: function editGroup(group) {
      this.edit_group = _.cloneDeep(group);
      return this.$store.dispatch('showDialog', 'edit_group');
    },
    editProperty: function editProperty(prop) {
      this.edit_prop = _.cloneDeep(prop);
      return this.$store.dispatch('showDialog', 'edit_prop');
    },
    editOption: function editOption(group, prop, option) {
      this.edit_group = group;
      this.edit_prop = prop;
      this.edit_option = option;
      return this.$store.dispatch('showDialog', 'edit_option');
    },
    //#####  MISC
    toggleShowGroup: function toggleShowGroup(idx) {
      if (this.toggle.groups[idx]) {
        return this.$set(this.toggle.groups, idx, false);
      } else {
        return this.$set(this.toggle.groups, idx, true);
      }
    },
    toggleShowOptions: function toggleShowOptions(idx) {
      if (this.toggle.options[idx]) {
        return this.$set(this.toggle.options, idx, false);
      } else {
        return this.$set(this.toggle.options, idx, true);
      }
    },
    cancel: function cancel() {
      return this.reset();
    },
    reset: function reset() {
      var reset;
      this.$store.dispatch('showDialog', null);
      reset = {
        g: false,
        p: false,
        o: false
      };
      this.show.add = reset;
      this.show.edit = reset;
      this.show.confirm = false;
      this.edit_group = {};
      this.edit_prop = {};
      return this.edit_option = {};
    },
    //##### VUEX MESSAGES
    newGroup: function newGroup(item) {
      item.sortorder = this.cprop_groups.getEmbeds('client_property_groups').length;
      this.$store.dispatch('addGroup', item);
      return this.reset();
    },
    newProperty: function newProperty(evt) {
      this.$store.dispatch('addProperty', evt);
      return this.reset();
    },
    newOption: function newOption(evt) {
      this.$store.dispatch('addOption', evt);
      return this.reset();
    },
    removeGroup: function removeGroup(group) {
      this.$store.dispatch('deleteGroup', group);
      return this.reset();
    },
    removeProperty: function removeProperty(prop) {
      this.$store.dispatch('deleteProperty', prop);
      return this.reset();
    },
    removeOption: function removeOption(option) {
      this.$store.dispatch('deleteOption', option);
      return this.reset();
    },
    updateGroup: function updateGroup(group) {
      this.$store.dispatch('updateGroup', group);
      return this.reset();
    },
    updateProperty: function updateProperty(prop) {
      this.$store.dispatch('updateProperty', prop);
      return this.reset();
    },
    updateOption: function updateOption(evt) {
      this.$store.dispatch('updateOption', evt);
      return this.reset();
    },
    reorderGroup: function reorderGroup(order) {
      var groups, new_groups;
      groups = _.cloneDeep(this.cprop_groups.getEmbeds('client_property_groups'));
      new_groups = order.map(function (item, idx) {
        return setNewSortOrder(this, item, idx);
      }, groups);
      return this.$store.dispatch('updateGroups', {
        groups: new_groups
      });
    },
    reorderProperty: function reorderProperty(order, dataset) {
      var group, new_props, props;
      group = this.cprop_groups.getEmbedByRelAndUID('client_property_groups', dataset.g_uid);
      props = _.cloneDeep(group.getEmbeds('client_property_definitions'));
      new_props = order.map(function (item, idx) {
        return setNewSortOrder(this, item, idx);
      }, props);
      return this.$store.dispatch('updateProps', {
        group: group,
        props: new_props
      });
    },
    reorderOption: function reorderOption(order, dataset) {
      var group, new_options, options, prop;
      group = this.cprop_groups.getEmbedByRelAndUID('client_property_groups', dataset.g_uid);
      prop = group.getEmbedByRelAndUID('client_property_definitions', dataset.p_uid);
      options = _.cloneDeep(prop.getEmbeds('client_property_option'));
      new_options = order.map(function (item, idx) {
        return setNewSortOrder(this, item, idx);
      }, options);
      return this.$store.dispatch('updateOptions', {
        group: group,
        prop: prop,
        options: new_options
      });
    }
  },
  created: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.are_loaded.resources) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.$store.dispatch('getServices');

            case 3:
              if (this.are_loaded.groups) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return this.$store.dispatch('getGroups');

            case 6:
              return _context.abrupt('return', _context.sent);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    return componentHandler.downgradeElements(this.$el);
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isLoaded']), (0, _vuex.mapState)(['cprop_groups', 'are_loaded']))
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(25);

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

var _vuex = __webpack_require__(3);

var _Sortable = __webpack_require__(74);

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setNewSortOrder,
    _extends = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

setNewSortOrder = function setNewSortOrder(collection, item, sortorder) {
  collection[item.dataset.order].sortorder = sortorder;
  return collection[item.dataset.order];
};

exports.default = {
  name: 'StatisticsAdministration',
  data: function data() {
    return {
      age_ranges: null
    };
  },
  directives: {
    'sortable': _Sortable2.default
  },
  methods: {
    addRange: function addRange() {
      return this.age_ranges.value.push(['', '']);
    },
    deleteRange: function deleteRange(idx) {
      return this.age_ranges.value.splice(idx, 1);
    },
    reorderRanges: function reorderRanges(new_index, old_index) {
      return console.log(new_index, old_index);
    },
    saveRanges: function saveRanges() {
      return this.$store.dispatch('updateConfig', this.age_ranges);
    }
  },
  created: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var c;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.are_loaded.resources) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.$store.dispatch('getServices');

            case 3:
              if (this.are_loaded.configs) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return this.$store.dispatch('getConfigs');

            case 6:
              c = this.configs.getEmbed('config', function (embed) {
                return embed.key === 'age_ranges';
              });
              return _context.abrupt('return', this.age_ranges = _.cloneDeep(c));

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    return componentHandler.downgradeElements(this.$el);
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isLoaded']), (0, _vuex.mapState)(['configs', 'are_loaded']))
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

var _BarChart = __webpack_require__(234);

var _BarChart2 = _interopRequireDefault(_BarChart);

var _Datefield = __webpack_require__(51);

var _Datefield2 = _interopRequireDefault(_Datefield);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _q = __webpack_require__(73);

var _q2 = _interopRequireDefault(_q);

var _StatisticsTableFull = __webpack_require__(233);

var _StatisticsTableFull2 = _interopRequireDefault(_StatisticsTableFull);

var _TableDownloadButton = __webpack_require__(78);

var _TableDownloadButton2 = _interopRequireDefault(_TableDownloadButton);

var _XHR = __webpack_require__(52);

var _XHR2 = _interopRequireDefault(_XHR);

var _vuex = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XHR;

XHR = new _XHR2.default();

exports.default = {
  name: 'Table',
  data: function data() {
    return {
      data_is_loaded: false,
      response: [],
      age_ranges: [],
      age_ranges_strings: [],
      clients_by_status: {
        active: [],
        closed: [],
        'new': []
      },
      years_of_birth: [],
      clients_by_status_and_age: {
        active: [],
        closed: [],
        'new': [],
        by_property: {}
      },
      start: (0, _moment2.default)().startOf('year').format('YYYY-MM-DD'),
      end: (0, _moment2.default)().endOf('year').format('YYYY-MM-DD'),
      sort_order: 'asc',
      sort_key: 'id'
    };
  },
  components: {
    'v-datefield': _Datefield2.default,
    'v-statisticstable-full': _StatisticsTableFull2.default,
    'v-barchart': _BarChart2.default,
    'download-button': _TableDownloadButton2.default
  },
  methods: {
    joinArray: function joinArray(arr, key) {
      var temp;
      if (_.isArray(arr)) {
        temp = arr.map(function (item) {
          return item[key];
        });
        return temp.join('<br>');
      } else {
        return arr;
      }
    },
    toggle: function toggle(val) {
      return console.log(val);
    },
    toggleSortOrder: function toggleSortOrder() {
      if (this.sort_order === 'asc') {
        this.sort_order = 'desc';
      } else {
        this.sort_order = 'asc';
      }
      return console.log(this.sort_order);
    },
    sort: function sort(key) {
      if (this.sort_key === key) {
        this.toggleSortOrder();
        return;
      }
      this.sort_key = key;
      return this.sort_order = 'asc';
    },
    sortClass: function sortClass(key) {
      if (key === this.sort_key) {
        if (this.sort_order === 'asc') {
          return {
            'mdl-data-table__header--sorted-ascending': true
          };
        } else {
          return {
            'mdl-data-table__header--sorted-descending': true
          };
        }
      }
    },
    groupByAge: function groupByAge(years_of_birth, clients) {
      var client, i, idx, j, len, len1, range, result;
      result = [];
      for (i = 0, len = clients.length; i < len; i++) {
        client = clients[i];
        for (idx = j = 0, len1 = years_of_birth.length; j < len1; idx = ++j) {
          range = years_of_birth[idx];
          result[idx] = result[idx] || {};
          if (client.year <= range[0] && client.year >= range[1]) {
            result[idx][client.gender] = (result[idx][client.gender] || []).concat(client);
          }
        }
      }
      return result;
    },
    groupByGender: function groupByGender(clients) {
      var result;
      result = {};
      ['male', 'female', 'hen'].map(function (gender) {
        var client, i, len, results;
        results = [];
        for (i = 0, len = clients.length; i < len; i++) {
          client = clients[i];
          results.push(result[client.gender] = (result.gender || []).concat(client));
        }
        return results;
      });
      return result;
    },
    getConfig: function getConfig(key) {
      var c;
      c = _.filter(this.config, {
        key: key
      });
      return c[0].value;
    },
    sumLengthByKey: function sumLengthByKey(arr, key) {
      var i, item, len, sum;
      sum = 0;
      for (i = 0, len = arr.length; i < len; i++) {
        item = arr[i];
        sum = sum + (item[key] || []).length;
      }
      return sum;
    },
    fetch: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(status) {
        var clients, e;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return XHR.get(this.resources.getLink('client.list').href, {
                  status: status + ',' + this.start + ',' + this.end
                });

              case 3:
                clients = _context.sent;
                return _context.abrupt('return', clients.getEmbeds('clients'));

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                e = _context.t0;
                return _context.abrupt('return', console.log(e));

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function fetch(_x) {
        return _ref.apply(this, arguments);
      }

      return fetch;
    }(),
    setupAgeRanges: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var age, e, i, len, ref, results, this_year;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this_year = (0, _moment2.default)().format('Y');
                _context2.next = 4;
                return this.$store.dispatch('getConfigs');

              case 4:
                this.age_ranges = this.getConfig('age_ranges');
                this.years_of_birth = [];
                this.age_ranges_strings = [];
                ref = this.age_ranges;
                results = [];
                for (i = 0, len = ref.length; i < len; i++) {
                  age = ref[i];
                  this.years_of_birth.push([this_year - age[0], this_year - age[1]]);
                  results.push(this.age_ranges_strings.push(age[0] + ' - ' + age[1]));
                }
                return _context2.abrupt('return', results);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                e = _context2.t0;
                return _context2.abrupt('return', console.log(e));

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function setupAgeRanges() {
        return _ref2.apply(this, arguments);
      }

      return setupAgeRanges;
    }(),
    setupProperties: function setupProperties(clients, cluster) {
      var client, group, i, len, prop, property, ref, results;
      ref = this.groups.getEmbeds('client_property_groups');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        results.push(function () {
          var j, len1, ref1, results1;
          ref1 = group.getEmbeds('client_property_definition');
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            property = ref1[j];
            results1.push(function () {
              var k, len2, results2;
              results2 = [];
              for (k = 0, len2 = clients.length; k < len2; k++) {
                client = clients[k];
                results2.push(function () {
                  var l, len3, ref2, results3;
                  ref2 = client.getEmbeds('client_property');
                  results3 = [];
                  for (l = 0, len3 = ref2.length; l < len3; l++) {
                    prop = ref2[l];
                    if (property.type === 'BOOLEAN' && prop.property_uid === property.uid && prop.value === true) {
                      results3.push(this.$set(cluster[group.uid]['properties'][prop.property_uid], client.gender, (cluster[group.uid]['properties'][prop.property_uid][client.gender] || []).concat(client)));
                    } else {
                      results3.push(void 0);
                    }
                  }
                  return results3;
                }.call(this));
              }
              return results2;
            }.call(this));
          }
          return results1;
        }.call(this));
      }
      return results;
    },
    initDataStructures: function initDataStructures() {
      var _this = this;

      return new _promise2.default(function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(resolve, reject) {
          var group, i, j, len, len1, property, ref, ref1;
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (_this.are_loaded.resources) {
                    _context3.next = 3;
                    break;
                  }

                  _context3.next = 3;
                  return _this.$store.dispatch('getServices');

                case 3:
                  if (_this.are_loaded.groups) {
                    _context3.next = 6;
                    break;
                  }

                  _context3.next = 6;
                  return _this.$store.dispatch('getGroups');

                case 6:
                  if (_this.are_loaded.activities) {
                    _context3.next = 9;
                    break;
                  }

                  _context3.next = 9;
                  return _this.$store.dispatch('getActivities', {
                    start: _this.start,
                    end: _this.end
                  });

                case 9:
                  ref = _this.groups.getEmbeds('client_property_groups');
                  // Setup structure by property
                  for (i = 0, len = ref.length; i < len; i++) {
                    group = ref[i];
                    _this.$set(_this.clients_by_status_and_age.by_property, group.uid, {
                      label: group.name,
                      properties: {}
                    });
                    ref1 = _.orderBy(group.getEmbeds('client_property_definition'), ['sortorder']);
                    for (j = 0, len1 = ref1.length; j < len1; j++) {
                      property = ref1[j];
                      _this.$set(_this.clients_by_status_and_age.by_property[group.uid]['properties'], property.uid, {
                        label: property.label,
                        type: property.type,
                        man: [],
                        woman: [],
                        hen: []
                      });
                    }
                  }
                  return _context3.abrupt('return', _this.setupAgeRanges().then(function () {
                    ['active', 'closed', 'new'].map(function (status) {
                      var k, len2, range, ref2, results;
                      if (_this.clients_by_status_and_age[status] === void 0) {
                        _this.$set(_this.clients_by_status_and_age, status, []);
                      }
                      ref2 = _this.age_ranges;
                      results = [];
                      for (k = 0, len2 = ref2.length; k < len2; k++) {
                        range = ref2[k];
                        results.push(_this.clients_by_status_and_age[status].push({
                          man: [],
                          woman: [],
                          hen: []
                        }));
                      }
                      return results;
                    });
                    return resolve(true);
                  }).catch(function (e) {
                    return reject(e);
                  }));

                case 12:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this);
        }));

        return function (_x2, _x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    sortedTable: function sortedTable(table) {
      var _this2 = this;

      return _.orderBy(table, [function (item) {
        var ref;
        return (ref = item[_this2.sort_key]) != null ? ref : '';
      }], [this.sort_order]);
    },
    refreshData: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var _this3 = this;

        var age_group, age_range_idx, client, clients, gender, grouped_by_age, i, idx, j, k, klients, l, len, len1, len2, len3, len4, m, ref, ref1, ref2, ref3, status;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.$store.dispatch('xhrIsLoading', true);
                _context4.next = 3;
                return this.initDataStructures();

              case 3:
                _context4.next = 5;
                return _promise2.default.all(['active', 'closed', 'new'].map(function (status) {
                  return _this3.fetch(status);
                }));

              case 5:
                clients = _context4.sent;

                ref = ['active', 'closed', 'new'];
                for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
                  status = ref[idx];
                  this.$set(this.clients_by_status, status, clients[idx]);
                }
                ref1 = this.clients_by_status_and_age;
                // Reset matrix
                for (status in ref1) {
                  clients = ref1[status];
                  for (age_range_idx = j = 0, len1 = clients.length; j < len1; age_range_idx = ++j) {
                    age_group = clients[age_range_idx];
                    ref2 = ['man', 'woman', 'hen'];
                    for (k = 0, len2 = ref2.length; k < len2; k++) {
                      gender = ref2[k];
                      this.$set(this.clients_by_status_and_age[status][age_range_idx], gender, []);
                    }
                  }
                }
                ref3 = this.clients_by_status;
                // Populate matrix
                for (status in ref3) {
                  clients = ref3[status];
                  grouped_by_age = this.groupByAge(this.years_of_birth, clients);
                  for (age_range_idx = l = 0, len3 = grouped_by_age.length; l < len3; age_range_idx = ++l) {
                    age_group = grouped_by_age[age_range_idx];
                    for (gender in age_group) {
                      klients = age_group[gender];
                      for (m = 0, len4 = klients.length; m < len4; m++) {
                        client = klients[m];
                        this.clients_by_status_and_age[status][age_range_idx][gender].push(client);
                      }
                    }
                  }
                }
                this.setupProperties(this.clients_by_status.active, this.clients_by_status_and_age.by_property);
                this.data_is_loaded = true;
                _context4.next = 16;
                return console.log('Data is refreshed: ', this.clients_by_status_and_age);

              case 16:
                return _context4.abrupt('return', this.$store.dispatch('xhrIsLoading', false));

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refreshData() {
        return _ref4.apply(this, arguments);
      }

      return refreshData;
    }(),
    getTableRef: function getTableRef(key) {
      var table, typeIsArray;
      typeIsArray = Array.isArray || function (value) {
        return {}.toString.call(value) === '[object Array]';
      };
      table = this.$refs[key];
      if (!typeIsArray(table)) {
        table = [table];
      }
      return table[0];
    }
  },
  created: function () {
    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              this.$store.dispatch('xhrIsLoading', true);
              _context5.next = 3;
              return this.initDataStructures();

            case 3:
              this.refreshData();
              return _context5.abrupt('return', this.$store.dispatch('xhrIsLoading', false));

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function created() {
      return _ref5.apply(this, arguments);
    }

    return created;
  }(),
  // updated: ->
  // typeIsArray = Array.isArray || ( value ) -> return {}.toString.call( value ) is '[object Array]'

  // @$nextTick ->
  //   for k, table of @$refs
  //     if not typeIsArray table then table = [table]
  //     @tables[k] = table[0]

  //   console.log 'tables: ', @tables
  watch: {
    'start': function start() {
      return this.refreshData();
    },
    'end': function end() {
      return this.refreshData();
    }
  },
  computed: (0, _vuex.mapState)({
    isLoading: function isLoading(state) {
      return state.xhr_is_loading;
    },
    resources: function resources(state) {
      return state.resources;
    },
    config: function config(state) {
      return state.configs.getEmbeds('config');
    },
    groups: function groups(state) {
      return state.cprop_groups;
    },
    are_loaded: function are_loaded(state) {
      return state.are_loaded;
    },
    activities: function activities(state) {
      return state.activities;
    }
  })
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(24);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfirmDialog',
  props: ['id', 'message'],
  data: function data() {
    return {
      s: false
    };
  },
  components: {
    'v-dialog': _Dialog2.default
  },
  watch: {
    show: function show() {
      return this.s = this.show;
    }
  },
  methods: {
    ok: function ok() {
      this.$emit('ok', true);
      return this.s = false;
    },
    cancel: function cancel() {
      this.$emit('cancel', false);
      return this.s = false;
    }
  },
  computed: (0, _vuex.mapState)({
    show: function show(state) {
      return state.dialog;
    }
  })
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Dialog',
  props: ['show'],
  watch: {
    'show': function show(_show) {
      if (_show) {
        this.$el.show();
        return this.$emit('open');
      } else {
        return this.$el.close();
      }
    }
  }
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(24);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OptionAddDialog',
  props: ['prop', 'group', 'id'],
  data: function data() {
    return {
      o: {
        value: null
      }
    };
  },
  components: {
    'v-dialog': _Dialog2.default,
    'v-textfield': _Textfield2.default
  },
  methods: {
    ok: function ok() {
      this.o.sortorder = this.prop.getEmbeds('client_property_option').length;
      this.o.property_uid = this.prop.uid;
      this.o.property_group_uid = this.group.uid;
      return this.$emit('ok', this.o);
    },
    cancel: function cancel() {
      this.$emit('cancel', false);
      return this.o.value = null;
    }
  },
  mounted: function mounted() {
    this.$on('show-modal', function () {
      return console.log('show-modal');
    });
    return this.$on('close-modal', function () {
      return console.log('close-modal');
    });
  },
  computed: (0, _vuex.mapState)({
    show: function show(state) {
      return state.dialog;
    }
  })
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(24);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OptionEditDialog',
  props: ['id', 'option', 'prop', 'group'],
  data: function data() {
    return {
      o: {}
    };
  },
  components: {
    'v-dialog': _Dialog2.default,
    'v-textfield': _Textfield2.default
  },
  methods: {
    ok: function ok() {
      return this.$emit('ok', this.o);
    },
    cancel: function cancel() {
      return this.$emit('cancel', false);
    }
  },
  computed: (0, _vuex.mapState)({
    show: function show(state) {
      if (state.dialog === this.id) {
        this.o = _.cloneDeep(this.option);
      }
      return state.dialog;
    }
  })
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(24);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _Textarea = __webpack_require__(236);

var _Textarea2 = _interopRequireDefault(_Textarea);

var _RadioButton = __webpack_require__(36);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _Checkbox = __webpack_require__(79);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Selectfield = __webpack_require__(81);

var _Selectfield2 = _interopRequireDefault(_Selectfield);

var _MultiCheckbox = __webpack_require__(80);

var _MultiCheckbox2 = _interopRequireDefault(_MultiCheckbox);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PropertyAddDialog',
  props: ['id', 'group', 'types'],
  data: function data() {
    return {
      p: {
        uid: null,
        name: null,
        label: null,
        description: null,
        type: null,
        is_active: true,
        client_property_group_id: null
      },
      options: null,
      show_error: false
    };
  },
  // errors: null
  components: {
    'v-dialog': _Dialog2.default,
    'v-textfield': _Textfield2.default,
    'v-textarea': _Textarea2.default,
    'v-radiobutton': _RadioButton2.default,
    'v-checkbox': _Checkbox2.default,
    'v-multi_checkbox': _MultiCheckbox2.default,
    'v-selectfield': _Selectfield2.default
  },
  methods: {
    ok: function ok() {
      this.p.client_property_group_id = this.group.uid;
      this.p.sortorder = this.group.getEmbeds('client_property_definitions').length;
      return this.$emit('ok', this.p);
    },
    cancel: function cancel() {
      return this.$emit('cancel', false);
    },
    set: function set(a, b) {
      return this.p[a] = b;
    },
    reset: function reset() {
      return this.p = {
        uid: null,
        name: null,
        label: null,
        description: null,
        type: null,
        is_active: true,
        client_property_group_id: null
      };
    },
    showErrors: function showErrors($event) {
      this.errors = $event;
      return this.show_error = true;
    }
  },
  computed: (0, _vuex.mapState)({
    show: function show(state) {
      return state.dialog;
    }
  })
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(24);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _Textarea = __webpack_require__(236);

var _Textarea2 = _interopRequireDefault(_Textarea);

var _RadioButton = __webpack_require__(36);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _Checkbox = __webpack_require__(79);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Selectfield = __webpack_require__(81);

var _Selectfield2 = _interopRequireDefault(_Selectfield);

var _MultiCheckbox = __webpack_require__(80);

var _MultiCheckbox2 = _interopRequireDefault(_MultiCheckbox);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PropertyEditDialog',
  props: ['id', 'prop', 'types'],
  data: function data() {
    return {
      p: {},
      options: null
    };
  },
  components: {
    'v-dialog': _Dialog2.default,
    'v-textfield': _Textfield2.default,
    'v-textarea': _Textarea2.default,
    'v-radiobutton': _RadioButton2.default,
    'v-checkbox': _Checkbox2.default,
    'v-multi_checkbox': _MultiCheckbox2.default,
    'v-selectfield': _Selectfield2.default
  },

  // watch:
  //   show: (s) ->
  //     if @p = _.cloneDeep @prop
  methods: {
    ok: function ok() {
      return this.$emit('ok', this.p);
    },
    cancel: function cancel() {
      return this.$emit('cancel', false);
    },
    set: function set(a, b) {
      return this.p[a] = b;
    }
  },
  computed: (0, _vuex.mapState)({
    show: function show(state) {
      if (state.dialog === this.id) {
        this.p = _.cloneDeep(this.prop);
      }
      return state.dialog;
    }
  })
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(24);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PropertyGroupAddDialog',
  props: ['id'],
  data: function data() {
    return {
      g: {
        name: ''
      }
    };
  },
  components: {
    'v-dialog': _Dialog2.default,
    'v-textfield': _Textfield2.default
  },
  watch: {
    show: function show() {
      this.s = this.show;
      if (!this.show) {
        return this.g.name = '';
      }
    }
  },
  methods: {
    ok: function ok() {
      return this.$emit('ok', this.g);
    },
    cancel: function cancel() {
      return this.$emit('cancel', false);
    }
  },
  computed: (0, _vuex.mapState)({
    show: function show(state) {
      return state.dialog;
    }
  })
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(24);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PropertyGroupEditDialog',
  props: ['id', 'group'],
  data: function data() {
    return {
      g: {}
    };
  },
  components: {
    'v-dialog': _Dialog2.default,
    'v-textfield': _Textfield2.default
  },
  methods: {
    ok: function ok() {
      return this.$emit('ok', this.g);
    },
    cancel: function cancel() {
      return this.$emit('cancel', false);
    }
  },
  computed: (0, _vuex.mapState)({
    show: function show(state) {
      if (state.dialog === this.id) {
        this.g = _.cloneDeep(this.group);
      }
      return state.dialog;
    }
  })
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  inserted: function inserted(el, bindings, vnode) {
    var container;
    // default append to <body>
    container = bindings.arg ? document.getElementById(bindings.arg) : document.body;
    if (container) {
      if (bindings.modifiers.prepend && container.firstChild) {
        container.insertBefore(el, container.firstChild);
      } else {
        container.appendChild(el);
      }
    } else {
      // bottom of target
      console.warn('v-' + name + ' target element id "' + bindings.arg + '" not found.');
    }
  },
  unbind: function unbind(el) {
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _c = __webpack_require__(375);

var _c2 = _interopRequireDefault(_c);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

var _d3Format = __webpack_require__(434);

var d3 = _interopRequireWildcard(_d3Format);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BarChart',
  props: ['id', 'start', 'end', 'data', 'dataLabels', 'xAxisCategories', 'xAxisLabel', 'yAxisLabel', 'title'],
  chart: {},
  methods: {
    formatData: function formatData(labels, data) {
      var columns, i, idx, label, len;
      columns = [];
      for (idx = i = 0, len = labels.length; i < len; idx = ++i) {
        label = labels[idx];
        columns.push(_.concat(label, data[idx]));
      }
      return columns;
    },
    formatDataPoints: function formatDataPoints(val) {
      var data_points, gender, i, idx, j, len, len1, range, ref, ref1, row;
      data_points = [];
      ref = ['woman', 'man', 'hen'];
      for (i = 0, len = ref.length; i < len; i++) {
        gender = ref[i];
        row = [];
        ref1 = this.xAxisCategories;
        for (idx = j = 0, len1 = ref1.length; j < len1; idx = ++j) {
          range = ref1[idx];
          row.push((val[idx][gender] || []).length);
        }
        if (row.length > 0) {
          data_points.push(row);
        }
      }
      return data_points;
    }
  },
  mounted: function mounted() {
    return this.chart = _c2.default.generate({
      title: this.title,
      data: {
        columns: this.formatData(this.dataLabels, this.formatDataPoints(this.data)),
        type: 'bar'
      },
      bar: {
        width: {
          ratio: 0.75
        }
      },
      padding: {
        left: 32,
        right: 16
      },
      bindto: '#' + this.id + '_chart',
      axis: {
        x: {
          label: this.xAxisLabel,
          type: 'category',
          categories: this.xAxisCategories
        },
        y: {
          label: this.yAxisLabel,
          tick: {
            format: function format(x) {
              if (x % 1 === 0) {
                return x;
              } else {
                return null;
              }
            }
          }
        }
      }
    });
  },
  watch: {
    'data': {
      handler: function handler(val) {
        return this.chart.load({
          columns: this.formatData(this.dataLabels, this.formatDataPoints(val))
        });
      },
      deep: true
    }
  }
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'IconToggleButton',
  props: ['id', 'iconToggleUp', 'iconToggleDown', 'disabled'],
  data: function data() {
    return {
      toggle: false
    };
  },
  methods: {
    clicked: function clicked() {
      if (!this.disabled) {
        this.toggle = !this.toggle;
        return this.$emit('clicked', this.toggle);
      }
    }
  },
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  }
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "MiniFabButton",
  props: ['id', 'icon', 'disabled'],
  methods: {
    clicked: function clicked() {
      return this.$emit('clicked', this);
    }
  },
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  }
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Snackbar",
  props: ['message'],
  watch: {
    'message': function message(msg) {
      return this.$el.MaterialSnackbar.showSnackbar({
        message: this.message
      });
    }
  }
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Spinner',
  props: ['is_active'],
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  }
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tableexport = __webpack_require__(229);

var _tableexport2 = _interopRequireDefault(_tableexport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TableDownloadButton',
  props: ['tableRef', 'filename'],
  data: function data() {
    return {
      table: null
    };
  },
  methods: {
    download: function download() {
      var export_data;
      if (this.tableRef != null) {
        this.table = (0, _tableexport2.default)(this.tableRef, {
          formats: ['csv'],
          filename: this.filename,
          exportButtons: false
        });
        export_data = this.table.getExportData()[this.tableRef.id]['csv'];
        return this.table.export2file(export_data.data, export_data.mimeType, export_data.filename, export_data.fileExtension);
      } else {
        return null;
      }
    }
  }
};

// mounted: ->
//   @$nextTick ->
//     # console.log 'tableRef:', @tableRef
//     if @tableRef?
//       @table = TableExport @tableRef,
//         formats: ['csv']
//         filename: @filename
//         exportButtons: false

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Checkbox",
  props: ['id', 'label', 'value'],
  mounted: function mounted() {
    componentHandler.upgradeElements(this.$el);
    return this.input = this.$refs.cbox;
  },
  updated: function updated() {
    if (this.$refs.cbox.checked) {
      return this.$el.MaterialCheckbox.check();
    } else {
      return this.$el.MaterialCheckbox.uncheck();
    }
  },
  methods: {
    onChange: function onChange(event) {
      return this.$emit('change', event.target.checked);
    }
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Datepicker = __webpack_require__(488);

var _Datepicker2 = _interopRequireDefault(_Datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Datefield',
  props: {
    id: '',
    label: '',
    value: '',
    validate: {
      default: ''
    }
  },
  components: {
    'v-datepicker': _Datepicker2.default
  },
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  methods: {
    onInput: function onInput(event) {
      this.$emit('input', event);
      return componentHandler.upgradeElements(this.$el);
    }
  },
  watch: {
    value: function value(val) {
      this.$validator.validate(this.label, val);
      if (this.errors.any()) {
        return this.$emit('errors', this.errors.all());
      }
    }
  },
  computed: {
    errorMsg: function errorMsg() {
      return this.errors.all().join('<br>');
    }
  }
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pikaday = __webpack_require__(461);

var _pikaday2 = _interopRequireDefault(_pikaday);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DatePicker',
  props: ['value'],
  data: function data() {
    return {
      picker: null
    };
  },
  mounted: function mounted() {
    var that;
    that = this;
    return this.picker = new _pikaday2.default({
      field: this.$el,
      firstDay: 1,
      showWeekNumber: true,
      format: 'YYYY-MM-DD',
      onSelect: function onSelect() {
        return that.$emit('input', that.picker.toString());
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    return this.picker.destroy();
  },
  methods: {
    onInput: function onInput(event) {
      return this.$emit('input', event.target.value);
    }
  }
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _quill = __webpack_require__(462);

var _quill2 = _interopRequireDefault(_quill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    id: null,
    value: {
      ops: []
    },
    author: {},
    formats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    keyBindings: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    output: {
      default: 'delta'
    },
    keyup: {
      default: null
    }
  },
  data: function data() {
    return {
      editor: {}
    };
  },
  mounted: function mounted() {
    var keyboard, that;
    that = this;
    this.editor = new _quill2.default(this.$refs.editor, {
      theme: 'snow',
      modules: {
        toolbar: true
      }
    });
    this.formats.map(function (format) {
      return this.editor.addFormat(format.name, format.options);
    });
    if (this.output !== 'delta') {
      this.editor.setHTML(this.value);
    } else {
      this.editor.setContents(this.value);
    }
    this.editor.on('text-change', function (delta, old, source) {
      var value;
      value = that.output !== 'delta' ? that.editor.getHTML() : that.editor.getContents();
      return that.value.ops = value.ops;
    });
    // @editor.on 'selection-change', (range) ->
    // @$emit('selection-change', @editor, range)
    if (typeof this.author !== 'undefined') {
      this.editor.addModule('authorship', {
        authorId: this.author
      });
    }
    if (this.keyBindings.length) {
      keyboard = this.editor.getModule('keyboard');
      return this.keyBindings.map(function (binding) {
        return keyboard.addHotkey({
          key: binding.key,
          metaKey: true
        }, binding.method.bind(this));
      });
    }
  },
  events: {
    'set-content': function setContent(content) {
      return this.editor.setContents(content);
    },
    'set-html': function setHtml(html) {
      return this.editor.setHTML(html);
    },
    'focus-editor': function focusEditor() {
      return this.focusEditor();
    }
  },
  methods: {
    sync: function sync() {
      return this.$nextTick(function () {
        return this.editor.setContents(this.value.ops);
      });
    },
    focusEditor: function focusEditor(e) {
      var classList, className, i, isSegment, len;
      if (e && e.srcElement) {
        classList = e.srcElement.classList;
        isSegment = false;
        for (i = 0, len = classList.length; i < len; i++) {
          className = classList[i];
          if (className === 'segment') {
            isSegment = true;
            return;
          }
        }
        if (!isSegment) {
          return;
        }
      }
      this.editor.focus();
      return this.editor.setSelection(this.editor.getLength() - 1, this.editor.getLength());
    }
  }
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "MultiCheckbox",
  data: function data() {
    return {
      option_values: []
    };
  },
  props: ['options', 'label', 'value'],
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  methods: {
    onChange: function onChange(event) {
      return this.$emit('change', this.option_values);
    },
    setChecked: function setChecked(el, checked) {
      if (checked) {
        return el.MaterialCheckbox.check();
      } else {
        return el.MaterialCheckbox.uncheck();
      }
    }
  },
  watch: {
    value: function value(val) {
      if (_.isArray(val)) {
        this.option_values = val;
      } else if (_.isNull(val)) {
        this.option_values = [];
      } else {
        this.option_values = [val];
      }
      return componentHandler.upgradeElements(this.$el);
    }
  },
  updated: function updated() {
    var i, label, len, ref, results;
    ref = this.$refs.cbox_label;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      label = ref[i];
      results.push(this.setChecked(label, label.firstChild.checked));
    }
    return results;
  }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Password',
  props: {
    id: '',
    label: '',
    value: '',
    tabindex: '',
    validate: {
      default: ''
    }
  },
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  methods: {
    onInput: function onInput(event) {
      this.$emit('input', event.target.value);
      return componentHandler.upgradeElements(this.$el);
    }
  },
  watch: {
    value: function value(val) {
      var _this = this;

      // console.log val, @label, this
      return this.$validator.validate(this.label, val).then(function () {
        return _this.$emit('no-errors', null);
      }).catch(function (err) {
        console.log(err);
        if (_this.errors.any()) {
          return _this.$emit('errors', _this.errors.all());
        }
      });
    }
  },
  computed: {
    errorMsg: function errorMsg() {
      return this.errors.all().join('<br>');
    }
  }
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'RadioButton',
  props: ['id', 'label', 'name', 'val', 'value', 'validate'],
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  methods: {
    onChange: function onChange(event) {
      this.$emit('input', event.target.value);
      if (this.errors.any()) {
        return this.$emit('errors', this.errors.all());
      }
    }
  },
  watch: {
    value: function value(val) {
      return this.$validator.validateAll().then(function (result) {
        return console.log(result);
      }).catch(function (err) {
        return console.log(er);
      });
    }
  }
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadioButton = __webpack_require__(36);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'RadioButtonGroup',
  props: ['id', 'labels', 'model', 'name', 'validate', 'values', 'value'],
  components: {
    'v-radiobutton': _RadioButton2.default
  },
  methods: {
    onInput: function onInput(val) {
      return this.$emit('input', val);
    }
  },
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  }
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Selectfield',
  props: ['id', 'label', 'value', 'options'],
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  updated: function updated() {
    return this.$refs.select.MaterialSelectfield.checkDirty();
  },
  beforeDestroy: function beforeDestroy() {
    return componentHandler.downgradeElements(this.$el);
  },
  methods: {
    onInput: function onInput(event) {
      return this.$emit('input', event.target.value);
    }
  }
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Switch",
  props: ['id', 'label', 'value'],
  mounted: function mounted() {
    componentHandler.upgradeElements(this.$el);
    return this.input = this.$refs.cbox;
  },
  updated: function updated() {
    if (this.$refs.cbox.checked) {
      return this.$el.MaterialSwitch.on();
    } else {
      return this.$el.MaterialSwitch.off();
    }
  },
  methods: {
    onChange: function onChange(event) {
      return this.$emit('change', event.target.checked);
    }
  }
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Textfield',
  props: ['id', 'label', 'value', 'rows'],
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  methods: {
    onInput: function onInput(event) {
      return this.$emit('input', event.target.value);
    }
  }
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Textfield',
  props: {
    id: '',
    label: '',
    value: '',
    tabindex: '',
    validate: {
      default: ''
    },
    isInvalid: false,
    errorMsg: null
  },
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  methods: {
    onInput: function onInput(event) {
      var _this = this;

      this.$emit('input', event.target.value);
      componentHandler.upgradeElements(this.$el);
      return this.$validator.validateAll().then(function () {
        return _this.$emit('valid');
      }).catch(function () {
        return _this.$emit('errors', _this.$validator.getErrors().errors);
      });
    }
  }
};

// computed:
//   errorMsg: () ->
//     @errors.all().join('<br>')

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(25);

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vuex = __webpack_require__(3);

var _Confirm = __webpack_require__(75);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _Datefield = __webpack_require__(51);

var _Datefield2 = _interopRequireDefault(_Datefield);

var _MiniFabButton = __webpack_require__(77);

var _MiniFabButton2 = _interopRequireDefault(_MiniFabButton);

var _Selectfield = __webpack_require__(81);

var _Selectfield2 = _interopRequireDefault(_Selectfield);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = {
  name: 'Activities',
  data: function data() {
    return {
      start: (0, _moment2.default)().startOf('year').format('YYYY-MM-DD'),
      end: (0, _moment2.default)().endOf('year').format('YYYY-MM-DD'),
      new_activity: null,
      edit_activity: null,
      edit_uid: null,
      show: {
        confirm: false,
        message: '',
        action: null
      },
      types: [{
        label: null,
        value: null
      }],
      sort_key: 'name',
      sort_order: 'asc'
    };
  },
  components: {
    'v-dialog-confirm': _Confirm2.default,
    'v-datefield': _Datefield2.default,
    'v-selectfield': _Selectfield2.default,
    'v-textfield': _Textfield2.default,
    'v-fab-button': _MiniFabButton2.default
  },
  methods: {
    cancel: function cancel() {
      this.$store.dispatch('showDialog', null);
      return this.show.confirm = false;
    },
    addActivity: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch('addActivity', this.new_activity);

              case 2:
                return _context.abrupt('return', this.reset());

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addActivity() {
        return _ref.apply(this, arguments);
      }

      return addActivity;
    }(),
    updateActivity: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(activity) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$store.dispatch('updateActivity', this.edit_activity);

              case 2:
                this.edit_uid = null;
                return _context2.abrupt('return', this.edit_activity = null);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateActivity(_x) {
        return _ref2.apply(this, arguments);
      }

      return updateActivity;
    }(),
    editActivity: function editActivity(activity) {
      this.edit_activity = _.cloneDeep(activity);
      return this.edit_uid = activity.uid;
    },
    deleteActivity: function deleteActivity(activity) {
      var _this = this;

      this.show.message = 'Säker på att du vill radera "' + activity.name + '"?';
      this.show.action = function () {
        return _this.removeActivity(activity);
      };
      return this.$store.dispatch('showDialog', 'confirm');
    },
    removeActivity: function removeActivity(activity) {
      this.$store.dispatch('deleteActivity', activity);
      this.$store.dispatch('showDialog', null);
      return this.show.confirm = false;
    },
    escapeKeyListener: function escapeKeyListener(evt) {
      if (evt.keyCode === 27) {
        return this.reset();
      }
    },
    reset: function reset() {
      this.new_activity = {
        uid: null,
        activity_type_uid: this.types.length > 0 ? this.types[0].value : null,
        name: null,
        start: (0, _moment2.default)().format('YYYY-MM-DD'),
        end: null
      };
      this.edit_uid = null;
      return console.log(this.new_activity.activity_type_uid);
    },
    setupTypes: function setupTypes() {
      var i, len, ref, results, type;
      this.types = [];
      ref = this.activity_types.getEmbeds('activity_type');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        type = ref[i];
        results.push(this.types.push({
          label: type.name,
          value: type.uid
        }));
      }
      return results;
    },
    toggleSortOrder: function toggleSortOrder() {
      if (this.sort_order === 'asc') {
        this.sort_order = 'desc';
      } else {
        this.sort_order = 'asc';
      }
      return console.log(this.sort_order);
    },
    sort: function sort(key) {
      if (this.sort_key === key) {
        this.toggleSortOrder();
        return;
      }
      this.sort_key = key;
      return this.sort_order = 'asc';
    },
    sortClass: function sortClass(key) {
      if (key === this.sort_key) {
        if (this.sort_order === 'asc') {
          return {
            'mdl-data-table__header--sorted-ascending': true
          };
        } else {
          return {
            'mdl-data-table__header--sorted-descending': true
          };
        }
      }
    },
    sortedActivities: function sortedActivities() {
      var _this2 = this;

      var act, activity, acts, i, len, ref;
      acts = [];
      ref = this.activities.getEmbeds('activities');
      for (i = 0, len = ref.length; i < len; i++) {
        activity = ref[i];
        act = _.cloneDeep(activity);
        act.activity_type_label = activity.getEmbed('activity_type').name;
        acts.push(act);
      }
      return _.orderBy(acts, [function (item) {
        var ref1;
        return (ref1 = item[_this2.sort_key]) != null ? ref1.toLowerCase() : void 0;
      }], [this.sort_order]);
    },
    fetchActivities: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$store.dispatch('getActivities', {
                  start: this.start,
                  end: this.end
                });

              case 2:
                return _context3.abrupt('return', _context3.sent);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchActivities() {
        return _ref3.apply(this, arguments);
      }

      return fetchActivities;
    }()
  },
  created: function () {
    var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              this.reset();

              if (this.are_loaded.resources) {
                _context4.next = 4;
                break;
              }

              _context4.next = 4;
              return this.$store.dispatch('getServices');

            case 4:
              if (this.are_loaded.activities) {
                _context4.next = 7;
                break;
              }

              _context4.next = 7;
              return this.$store.dispatch('getActivities', {
                start: this.start,
                end: this.end
              });

            case 7:
              if (this.are_loaded.activity_types) {
                _context4.next = 10;
                break;
              }

              _context4.next = 10;
              return this.$store.dispatch('getActivityTypes');

            case 10:
              this.setupTypes();
              this.reset();
              return _context4.abrupt('return', document.addEventListener('keyup', this.escapeKeyListener));

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function created() {
      return _ref4.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    return componentHandler.downgradeElements(this.$el);
  },
  destroyed: function destroyed() {
    return document.removeEventListener('keyup', this.escapeKeyListener);
  },
  watch: {
    'start': function start() {
      return this.fetchActivities();
    },
    'end': function end() {
      return this.fetchActivities();
    }
  },
  computed: _extends({}, (0, _vuex.mapState)(['are_loaded', 'activity_types', 'activities']))
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(3);

var _Properties = __webpack_require__(477);

var _Properties2 = _interopRequireDefault(_Properties);

var _Statistics = __webpack_require__(478);

var _Statistics2 = _interopRequireDefault(_Statistics);

var _Activities = __webpack_require__(476);

var _Activities2 = _interopRequireDefault(_Activities);

var _Table = __webpack_require__(479);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Administration',
  components: {
    'v-properties': _Properties2.default,
    'v-statistics': _Statistics2.default,
    'v-activities': _Activities2.default,
    'v-table': _Table2.default
  },
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    return componentHandler.downgradeElements(this.$el);
  },
  computed: (0, _vuex.mapState)({
    isLoading: function isLoading(state) {
      return state.xhr_is_loadings;
    }
  })
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Checkbox = __webpack_require__(79);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _ClientList = __webpack_require__(232);

var _ClientList2 = _interopRequireDefault(_ClientList);

var _Datefield = __webpack_require__(51);

var _Datefield2 = _interopRequireDefault(_Datefield);

var _Editor = __webpack_require__(489);

var _Editor2 = _interopRequireDefault(_Editor);

var _HALSONResource = __webpack_require__(37);

var _HALSONResource2 = _interopRequireDefault(_HALSONResource);

var _MiniFabButton = __webpack_require__(77);

var _MiniFabButton2 = _interopRequireDefault(_MiniFabButton);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _MultiCheckbox = __webpack_require__(80);

var _MultiCheckbox2 = _interopRequireDefault(_MultiCheckbox);

var _q = __webpack_require__(73);

var _q2 = _interopRequireDefault(_q);

var _RadioButton = __webpack_require__(36);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _RadioButtonGroup = __webpack_require__(491);

var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);

var _Spinner = __webpack_require__(235);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _transferDom = __webpack_require__(486);

var _transferDom2 = _interopRequireDefault(_transferDom);

var _urlTemplate = __webpack_require__(50);

var _urlTemplate2 = _interopRequireDefault(_urlTemplate);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(3);

var _sprintfJs = __webpack_require__(464);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ClientForm',
  data: function data() {
    return {
      debug: false,
      email: null,
      min_year: (0, _moment2.default)().year() - 85,
      max_year: (0, _moment2.default)().year() - 18,
      client: {
        id: null
      },
      props: {},
      original_props: {},
      props_url_tmpl: null,
      id_is_invalid: false,
      year_is_invalid: false
    };
  },
  components: {
    'v-field': _Datefield2.default,
    'v-textfield': _Textfield2.default,
    'v-datefield': _Datefield2.default,
    'v-radiobutton': _RadioButton2.default,
    'v-radiobutton-group': _RadioButtonGroup2.default,
    'v-checkbox': _Checkbox2.default,
    'v-multi_checkbox': _MultiCheckbox2.default,
    'v-editor': _Editor2.default,
    'v-client-list': _ClientList2.default,
    'v-fab-button': _MiniFabButton2.default
  },
  directives: {
    'transfer-dom': _transferDom2.default
  },
  methods: {
    toggleDebug: function toggleDebug() {
      this.$validator.validateAll().then(function (result) {
        return console.log('validation: ', result);
      });
      return this.debug = !this.debug;
    },
    resetProps: function resetProps() {
      var group, i, len, prop, ref, results;
      ref = this.groups.getEmbeds('client_property_groups');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        results.push(function () {
          var j, len1, ref1, results1;
          ref1 = group.getEmbeds('client_property_definition');
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            prop = ref1[j];
            results1.push(this.$set(this.props, prop.uid, null));
          }
          return results1;
        }.call(this));
      }
      return results;
    },
    checkYear: function checkYear() {
      return this.year_is_invalid = isNaN(this.client.year) || this.client.year < this.min_year || this.client.year > this.max_year;
    },
    saveClient: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(client) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch('saveClient', [client, this.original_props]);

              case 2:
                componentHandler.upgradeElements(this.$el);
                return _context.abrupt('return', this.$emit('message', 'Sparad...'));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveClient(_x) {
        return _ref.apply(this, arguments);
      }

      return saveClient;
    }(),
    newClient: function newClient() {
      var _this = this;

      this.$store.dispatch('newClient');
      return this.$nextTick(function () {
        _this.$refs['first_tab'].click();
        return componentHandler.upgradeElements(_this.$el);
      });
    },
    getPropertyValue: function getPropertyValue(uid) {
      var idx;
      idx = _.findIndex(this.client.getEmbeds('client_property'), ['property_uid', uid]);
      if (idx === -1) {
        this.client.addEmbed('client_property', this.newProperty(this.client.uid, uid));
        return null;
      } else {
        return this.client.getEmbeds('client_property')[idx].value;
      }
    },
    setPropertyValue: function setPropertyValue(uid, value) {
      var prop;
      console.log(uid, value);
      prop = this.client.getEmbed('client_property', function (embed) {
        return embed.property_uid === uid;
      });
      return this.$set(prop, 'value', value);
    },
    newProperty: function newProperty(client_uid, property_uid) {
      var prop, url;
      prop = (0, _HALSONResource2.default)({
        client_uid: client_uid,
        property_uid: property_uid,
        value: null
      });
      url = this.props_url_tmpl.expand({
        client_id: client_uid,
        prop_id: property_uid
      });
      return prop.addLink('self', url);
    }
  },
  created: function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.client = _.cloneDeep(this.selected_client);

              if (this.are_loaded.resources) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return this.$store.dispatch('getServices');

            case 4:
              this.props_url_tmpl = _urlTemplate2.default.parse(this.$store.getters.resourceURL('client_property.get'));

              if (this.are_loaded.groups) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return this.$store.dispatch('getGroups');

            case 8:
              return _context2.abrupt('return', this.resetProps());

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _ref2.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    return componentHandler.upgradeElements(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    return componentHandler.downgradeElements(this.$el);
  },
  watch: {
    selected_client: function selected_client(item) {
      var group, i, j, len, len1, prop, ref, ref1;
      if (this.selected_client != null) {
        this.client = _.cloneDeep(this.selected_client);
        ref = this.groups.getEmbeds('client_property_groups');
        for (i = 0, len = ref.length; i < len; i++) {
          group = ref[i];
          ref1 = group.getEmbeds('client_property_definition');
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            prop = ref1[j];
            this.props[prop.uid] = this.getPropertyValue(prop.uid);
          }
        }
        this.original_props = _.clone(this.props);
        return this.$validator.validateAll();
      }
    },
    'client.id': function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(id) {
        var ok;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$store.dispatch('checkClientId', {
                  uid: this.client.uid,
                  id: id
                });

              case 2:
                ok = _context3.sent;

                if (!ok) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return', this.id_is_invalid = false);

              case 7:
                return _context3.abrupt('return', this.id_is_invalid = true);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function clientId(_x2) {
        return _ref3.apply(this, arguments);
      }

      return clientId;
    }()
  },
  computed: (0, _vuex.mapState)({
    selected_client: function selected_client(state) {
      return state.selected_client;
    },
    isLoading: function isLoading(state) {
      return state.xhr_is_loading;
    },
    groups: function groups(state) {
      return state.cprop_groups;
    },
    resources: function resources(state) {
      return state.resources;
    },
    are_loaded: function are_loaded(state) {
      return state.are_loaded;
    }
  })
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MenuDrawer = __webpack_require__(474);

var _MenuDrawer2 = _interopRequireDefault(_MenuDrawer);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Content',
  components: {
    'menu-drawer': _MenuDrawer2.default
  },
  updated: function updated() {
    return this.$nextTick(function () {
      return componentHandler.upgradeElements(this.$el);
    });
  },
  computed: (0, _vuex.mapState)({
    version: function version(state) {
      return state.version;
    },
    api_version: function api_version(state) {
      if (state.resources != null) {
        return state.resources.version;
      } else {
        return null;
      }
    },
    isLoading: function isLoading(state) {
      return state.xhr_is_loading;
    }
  })
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Textfield = __webpack_require__(9);

var _Textfield2 = _interopRequireDefault(_Textfield);

var _Password = __webpack_require__(490);

var _Password2 = _interopRequireDefault(_Password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Login',
  components: {
    'v-textfield': _Textfield2.default,
    'v-password': _Password2.default
  },
  data: function data() {
    return {
      username: null,
      password: null,
      error: false
    };
  },
  methods: {
    onError: function onError(errors) {
      var error, i, len, results;
      console.log(errors);
      this.errors.clear();
      results = [];
      for (i = 0, len = errors.length; i < len; i++) {
        error = errors[i];
        results.push(this.$validator.errorBag.add(error.field, error.msg, error.ruleName));
      }
      return results;
    },
    login: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                _context.next = 3;
                return this.$store.dispatch('login', {
                  username: self.username,
                  password: self.password
                }).catch(function (err) {
                  console.log('Error i Login.vue');
                  self.error = true;
                  self.username = null;
                  self.password = null;
                  return setTimeout(function () {
                    return self.error = false;
                  }, 3000);
                });

              case 3:
                return _context.abrupt('return', this.$router.push('/start'));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login() {
        return _ref.apply(this, arguments);
      }

      return login;
    }()
  }
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__(15);

var _ = _interopRequireWildcard(_lodash);

var _BarChart = __webpack_require__(234);

var _BarChart2 = _interopRequireDefault(_BarChart);

var _Datefield = __webpack_require__(51);

var _Datefield2 = _interopRequireDefault(_Datefield);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _q = __webpack_require__(73);

var _q2 = _interopRequireDefault(_q);

var _StatisticsTableFull = __webpack_require__(233);

var _StatisticsTableFull2 = _interopRequireDefault(_StatisticsTableFull);

var _TableDownloadButton = __webpack_require__(78);

var _TableDownloadButton2 = _interopRequireDefault(_TableDownloadButton);

var _XHR = __webpack_require__(52);

var _XHR2 = _interopRequireDefault(_XHR);

var _vuex = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XHR;

XHR = new _XHR2.default();

exports.default = {
  name: 'Statistics',
  data: function data() {
    return {
      data_is_loaded: false,
      response: [],
      age_ranges: [],
      age_ranges_strings: [],
      clients_by_status: {
        active: [],
        closed: [],
        'new': []
      },
      years_of_birth: [],
      clients_by_status_and_age: {
        active: [],
        closed: [],
        'new': [],
        by_property: {}
      },
      start: (0, _moment2.default)().startOf('year').format('YYYY-MM-DD'),
      end: (0, _moment2.default)().endOf('year').format('YYYY-MM-DD'),
      sort_order: 'asc',
      sort_key: 'name'
    };
  },
  components: {
    'v-datefield': _Datefield2.default,
    'v-statisticstable-full': _StatisticsTableFull2.default,
    'v-barchart': _BarChart2.default,
    'download-button': _TableDownloadButton2.default
  },
  methods: {
    toggle: function toggle(val) {
      return console.log(val);
    },
    groupByAge: function groupByAge(years_of_birth, clients) {
      var client, i, idx, j, len, len1, range, result;
      result = [];
      for (i = 0, len = clients.length; i < len; i++) {
        client = clients[i];
        for (idx = j = 0, len1 = years_of_birth.length; j < len1; idx = ++j) {
          range = years_of_birth[idx];
          result[idx] = result[idx] || {};
          if (client.year <= range[0] && client.year >= range[1]) {
            result[idx][client.gender] = (result[idx][client.gender] || []).concat(client);
          }
        }
      }
      return result;
    },
    groupByGender: function groupByGender(clients) {
      var result;
      result = {};
      ['male', 'female', 'hen'].map(function (gender) {
        var client, i, len, results;
        results = [];
        for (i = 0, len = clients.length; i < len; i++) {
          client = clients[i];
          results.push(result[client.gender] = (result.gender || []).concat(client));
        }
        return results;
      });
      return result;
    },
    getConfig: function getConfig(key) {
      var c;
      c = _.filter(this.config, {
        key: key
      });
      return c[0].value;
    },
    sumLengthByKey: function sumLengthByKey(arr, key) {
      var i, item, len, sum;
      sum = 0;
      for (i = 0, len = arr.length; i < len; i++) {
        item = arr[i];
        sum = sum + (item[key] || []).length;
      }
      return sum;
    },
    fetch: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(status) {
        var clients, e;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return XHR.get(this.resources.getLink('client.list').href, {
                  status: status + ',' + this.start + ',' + this.end
                });

              case 3:
                clients = _context.sent;
                return _context.abrupt('return', clients.getEmbeds('clients'));

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                e = _context.t0;
                return _context.abrupt('return', console.log(e));

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function fetch(_x) {
        return _ref.apply(this, arguments);
      }

      return fetch;
    }(),
    setupAgeRanges: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var age, e, i, len, ref, results, this_year;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this_year = (0, _moment2.default)().format('Y');
                _context2.next = 4;
                return this.$store.dispatch('getConfigs');

              case 4:
                this.age_ranges = this.getConfig('age_ranges');
                this.years_of_birth = [];
                this.age_ranges_strings = [];
                ref = this.age_ranges;
                results = [];
                for (i = 0, len = ref.length; i < len; i++) {
                  age = ref[i];
                  this.years_of_birth.push([this_year - age[0], this_year - age[1]]);
                  results.push(this.age_ranges_strings.push(age[0] + ' - ' + age[1]));
                }
                return _context2.abrupt('return', results);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                e = _context2.t0;
                return _context2.abrupt('return', console.log(e));

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function setupAgeRanges() {
        return _ref2.apply(this, arguments);
      }

      return setupAgeRanges;
    }(),
    setupProperties: function setupProperties(clients, cluster) {
      var c, client, group, i, len, prop, property, ref, results;
      ref = this.groups.getEmbeds('client_property_groups');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        results.push(function () {
          var j, len1, ref1, results1;
          ref1 = group.getEmbeds('client_property_definitions');
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            property = ref1[j];
            results1.push(function () {
              var k, len2, results2;
              results2 = [];
              for (k = 0, len2 = clients.length; k < len2; k++) {
                client = clients[k];
                results2.push(function () {
                  var l, len3, ref2, ref3, results3;
                  ref2 = client.getEmbeds('client_property');
                  results3 = [];
                  for (l = 0, len3 = ref2.length; l < len3; l++) {
                    prop = ref2[l];
                    if (property.type === 'BOOLEAN' && prop.property_uid === property.uid && prop.value === true) {
                      c = (ref3 = cluster[group.uid]['properties'][prop.property_uid][client.gender]) != null ? ref3 : [];
                      results3.push(this.$set(cluster[group.uid]['properties'][prop.property_uid], client.gender, c.concat(client)));
                    } else {
                      results3.push(void 0);
                    }
                  }
                  return results3;
                }.call(this));
              }
              return results2;
            }.call(this));
          }
          return results1;
        }.call(this));
      }
      return results;
    },
    initDataStructures: function initDataStructures() {
      var _this = this;

      return new _promise2.default(function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(resolve, reject) {
          var group, i, j, len, len1, property, ref, ref1;
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (_this.are_loaded.resources) {
                    _context3.next = 3;
                    break;
                  }

                  _context3.next = 3;
                  return _this.$store.dispatch('getServices');

                case 3:
                  if (_this.are_loaded.groups) {
                    _context3.next = 6;
                    break;
                  }

                  _context3.next = 6;
                  return _this.$store.dispatch('getGroups');

                case 6:
                  if (_this.are_loaded.activities) {
                    _context3.next = 9;
                    break;
                  }

                  _context3.next = 9;
                  return _this.$store.dispatch('getActivities', {
                    start: _this.start,
                    end: _this.end
                  });

                case 9:
                  ref = _this.groups.getEmbeds('client_property_groups');
                  // Setup structure by property
                  for (i = 0, len = ref.length; i < len; i++) {
                    group = ref[i];
                    _this.$set(_this.clients_by_status_and_age.by_property, group.uid, {
                      label: group.name,
                      properties: {}
                    });
                    ref1 = _.orderBy(group.getEmbeds('client_property_definitions'), ['sortorder']);
                    for (j = 0, len1 = ref1.length; j < len1; j++) {
                      property = ref1[j];
                      _this.$set(_this.clients_by_status_and_age.by_property[group.uid]['properties'], property.uid, {
                        label: property.label,
                        type: property.type,
                        man: [],
                        woman: [],
                        hen: []
                      });
                    }
                  }
                  return _context3.abrupt('return', _this.setupAgeRanges().then(function () {
                    ['active', 'closed', 'new'].map(function (status) {
                      var k, len2, range, ref2, results;
                      if (_this.clients_by_status_and_age[status] === void 0) {
                        _this.$set(_this.clients_by_status_and_age, status, []);
                      }
                      ref2 = _this.age_ranges;
                      results = [];
                      for (k = 0, len2 = ref2.length; k < len2; k++) {
                        range = ref2[k];
                        results.push(_this.clients_by_status_and_age[status].push({
                          man: [],
                          woman: [],
                          hen: []
                        }));
                      }
                      return results;
                    });
                    return resolve(true);
                  }).catch(function (e) {
                    return reject(e);
                  }));

                case 12:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this);
        }));

        return function (_x2, _x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    toggleSortOrder: function toggleSortOrder() {
      if (this.sort_order === 'asc') {
        this.sort_order = 'desc';
      } else {
        this.sort_order = 'asc';
      }
      return console.log(this.sort_order);
    },
    sort: function sort(key) {
      if (this.sort_key === key) {
        this.toggleSortOrder();
        return;
      }
      this.sort_key = key;
      return this.sort_order = 'asc';
    },
    sortClass: function sortClass(key) {
      if (key === this.sort_key) {
        if (this.sort_order === 'asc') {
          return {
            'mdl-data-table__header--sorted-ascending': true
          };
        } else {
          return {
            'mdl-data-table__header--sorted-descending': true
          };
        }
      }
    },
    sortedActivities: function sortedActivities() {
      var _this2 = this;

      var act, activity, acts, i, len, ref;
      acts = [];
      ref = this.activities.getEmbeds('activities');
      for (i = 0, len = ref.length; i < len; i++) {
        activity = ref[i];
        act = _.cloneDeep(activity);
        act.activity_type_label = activity.getEmbed('activity_type').name;
        acts.push(act);
      }
      return _.orderBy(acts, [function (item) {
        var ref1;
        return (ref1 = item[_this2.sort_key]) != null ? ref1.toLowerCase() : void 0;
      }], [this.sort_order]);
    },
    refreshData: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var _this3 = this;

        var age_group, age_range_idx, client, clients, gender, grouped_by_age, i, idx, j, k, klients, l, len, len1, len2, len3, len4, m, ref, ref1, ref2, ref3, status;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.$store.dispatch('xhrIsLoading', true);
                _context4.next = 3;
                return this.initDataStructures();

              case 3:
                _context4.next = 5;
                return this.$store.dispatch('getActivities', {
                  start: this.start,
                  end: this.end
                });

              case 5:
                _context4.next = 7;
                return _promise2.default.all(['active', 'closed', 'new'].map(function (status) {
                  return _this3.fetch(status);
                }));

              case 7:
                clients = _context4.sent;

                ref = ['active', 'closed', 'new'];
                for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
                  status = ref[idx];
                  this.$set(this.clients_by_status, status, clients[idx]);
                }
                ref1 = this.clients_by_status_and_age;
                // Reset matrix
                for (status in ref1) {
                  clients = ref1[status];
                  for (age_range_idx = j = 0, len1 = clients.length; j < len1; age_range_idx = ++j) {
                    age_group = clients[age_range_idx];
                    ref2 = ['man', 'woman', 'hen'];
                    for (k = 0, len2 = ref2.length; k < len2; k++) {
                      gender = ref2[k];
                      this.$set(this.clients_by_status_and_age[status][age_range_idx], gender, []);
                    }
                  }
                }
                ref3 = this.clients_by_status;
                // Populate matrix
                for (status in ref3) {
                  clients = ref3[status];
                  grouped_by_age = this.groupByAge(this.years_of_birth, clients);
                  for (age_range_idx = l = 0, len3 = grouped_by_age.length; l < len3; age_range_idx = ++l) {
                    age_group = grouped_by_age[age_range_idx];
                    for (gender in age_group) {
                      klients = age_group[gender];
                      for (m = 0, len4 = klients.length; m < len4; m++) {
                        client = klients[m];
                        this.clients_by_status_and_age[status][age_range_idx][gender].push(client);
                      }
                    }
                  }
                }
                this.setupProperties(this.clients_by_status.active, this.clients_by_status_and_age.by_property);
                this.data_is_loaded = true;
                _context4.next = 18;
                return console.log('Data is refreshed: ', this.clients_by_status_and_age);

              case 18:
                return _context4.abrupt('return', this.$store.dispatch('xhrIsLoading', false));

              case 19:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refreshData() {
        return _ref4.apply(this, arguments);
      }

      return refreshData;
    }(),
    getTableRef: function getTableRef(key) {
      var table, typeIsArray;
      typeIsArray = Array.isArray || function (value) {
        return {}.toString.call(value) === '[object Array]';
      };
      table = this.$refs[key];
      if (!typeIsArray(table)) {
        table = [table];
      }
      return table[0];
    }
  },
  created: function () {
    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              this.$store.dispatch('xhrIsLoading', true);
              _context5.next = 3;
              return this.initDataStructures();

            case 3:
              this.refreshData();
              return _context5.abrupt('return', this.$store.dispatch('xhrIsLoading', false));

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function created() {
      return _ref5.apply(this, arguments);
    }

    return created;
  }(),
  // updated: ->
  // typeIsArray = Array.isArray || ( value ) -> return {}.toString.call( value ) is '[object Array]'

  // @$nextTick ->
  //   for k, table of @$refs
  //     if not typeIsArray table then table = [table]
  //     @tables[k] = table[0]

  //   console.log 'tables: ', @tables
  watch: {
    'start': function start() {
      return this.refreshData();
    },
    'end': function end() {
      return this.refreshData();
    }
  },
  computed: (0, _vuex.mapState)({
    isLoading: function isLoading(state) {
      return state.xhr_is_loading;
    },
    resources: function resources(state) {
      return state.resources;
    },
    config: function config(state) {
      return state.configs.getEmbeds('config');
    },
    groups: function groups(state) {
      return state.cprop_groups;
    },
    are_loaded: function are_loaded(state) {
      return state.are_loaded;
    },
    activities: function activities(state) {
      return state.activities;
    }
  })
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(249);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(238);

var _router2 = _interopRequireDefault(_router);

var _vuex = __webpack_require__(239);

var _vuex2 = _interopRequireDefault(_vuex);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(242);

__webpack_require__(243);

__webpack_require__(244);

__webpack_require__(241);

__webpack_require__(245);

var _vueChartist = __webpack_require__(247);

var _vueChartist2 = _interopRequireDefault(_vueChartist);

var _veeValidate = __webpack_require__(246);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _sv = __webpack_require__(240);

var _sv2 = _interopRequireDefault(_sv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_veeValidate2.default, {
  locale: 'sv',
  dictionary: {
    sv: {
      messages: _sv2.default
    }
  }
});

_vue2.default.use(_vueChartist2.default, {
  messageNoData: 'You have not enough data',
  classNoData: 'empty'
});

_vue2.default.config.productionTip = false;

_router2.default.beforeEach(function (from, to, next) {
  console.log(_vuex2.default.state.user.is_logged_in, from.path, to.path);
  if (_vuex2.default.state.user.is_logged_in) {
    console.log('going next');
    next();
    return;
  }
  if (from.path !== '/login') {
    console.log('going to login');
    next('/login');
    return;
  }
  console.log('faller igenom');
  return next();
});

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  },
  store: _vuex2.default
});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// wsse.js - Generate WSSE authentication header in JavaScript
// (C) 2005 Victor R. Ruiz <victor*sixapart.com> - http://rvr.typepad.com/

// Parts:
//   SHA-1 library (C) 2000-2002 Paul Johnston - BSD license
//   ISO 8601 function (C) 2000 JF Walker All Rights
//   Base64 function (C) aardwulf systems - Creative Commons

// Example call:

//   var w = wsseHeader(Username, Password);
//   alert('X-WSSE: ' + w);

// Changelog:
//   2005.07.21 - Release 1.0

/* hex output format. 0 - lowercase; 1 - uppercase        */
/*
 * Convert an array of big-endian words to a base-64 string
 */
/*
 * Convert an array of big-endian words to a hex string.
 */
/*
 * Convert an array of big-endian words to a string
 */
/* base-64 pad character. "=" for strict RFC compliance   */
/*
 * Calculate the HMAC-SHA1 of a key and some data
 */
/*
 * Calculate the SHA-1 of an array of big-endian words, and a bit length
 */
/* bits per input character. 8 - ASCII; 16 - Unicode      */
/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */
/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
/*
 * Bitwise rotate a 32-bit number to the left.
 */
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
/*
 * Perform the appropriate triplet combination function for the current
 * iteration
 */
/*
 * Determine the appropriate additive constant for the current iteration
 */
/*
 * Perform a simple self-test to see if the VM is working
 */
/*
 * Convert an 8-bit or 16-bit string to an array of big-endian words
 * In 8-bit function, characters >255 have their hi-byte silently ignored.
 */
var b64_hmac_sha1, b64_sha1, b64pad, binb2b64, binb2hex, binb2str, chrsz, core_hmac_sha1, core_sha1, encode64, hex_hmac_sha1, hex_sha1, hexcase, isodatetime, rol, safe_add, sha1_ft, sha1_kt, sha1_vm_test, str2binb, str_hmac_sha1, str_sha1, wsse;

hexcase = 0;

b64pad = '=';

chrsz = 8;

hex_sha1 = function hex_sha1(s) {
  return binb2hex(core_sha1(str2binb(s), s.length * chrsz));
};

b64_sha1 = function b64_sha1(s) {
  return binb2b64(core_sha1(str2binb(s), s.length * chrsz));
};

str_sha1 = function str_sha1(s) {
  return binb2str(core_sha1(str2binb(s), s.length * chrsz));
};

hex_hmac_sha1 = function hex_hmac_sha1(key, data) {
  return binb2hex(core_hmac_sha1(key, data));
};

b64_hmac_sha1 = function b64_hmac_sha1(key, data) {
  return binb2b64(core_hmac_sha1(key, data));
};

str_hmac_sha1 = function str_hmac_sha1(key, data) {
  return binb2str(core_hmac_sha1(key, data));
};

sha1_vm_test = function sha1_vm_test() {
  return hex_sha1('abc') === 'a9993e364706816aba3e25717850c26c9cd0d89d';
};

core_sha1 = function core_sha1(x, len) {
  var a, b, c, d, e, i, j, olda, oldb, oldc, oldd, olde, t, w;
  /* append padding */
  x[len >> 5] |= 0x80 << 24 - len % 32;
  x[(len + 64 >> 9 << 4) + 15] = len;
  w = Array(80);
  a = 1732584193;
  b = -271733879;
  c = -1732584194;
  d = 271733878;
  e = -1009589776;
  i = 0;
  while (i < x.length) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    olde = e;
    j = 0;
    while (j < 80) {
      if (j < 16) {
        w[j] = x[i + j];
      } else {
        w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
      }
      t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
      e = d;
      d = c;
      c = rol(b, 30);
      b = a;
      a = t;
      j++;
    }
    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
    e = safe_add(e, olde);
    i += 16;
  }
  return Array(a, b, c, d, e);
};

sha1_ft = function sha1_ft(t, b, c, d) {
  if (t < 20) {
    return b & c | ~b & d;
  }
  if (t < 40) {
    return b ^ c ^ d;
  }
  if (t < 60) {
    return b & c | b & d | c & d;
  }
  return b ^ c ^ d;
};

sha1_kt = function sha1_kt(t) {
  if (t < 20) {
    return 1518500249;
  } else if (t < 40) {
    return 1859775393;
  } else if (t < 60) {
    return -1894007588;
  } else {
    return -899497514;
  }
};

core_hmac_sha1 = function core_hmac_sha1(key, data) {
  var bkey, hash, i, ipad, opad;
  bkey = str2binb(key);
  if (bkey.length > 16) {
    bkey = core_sha1(bkey, key.length * chrsz);
  }
  ipad = Array(16);
  opad = Array(16);
  i = 0;
  while (i < 16) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
    i++;
  }
  hash = core_sha1(ipad.concat(str2binb(data)), 512 + data.length * chrsz);
  return core_sha1(opad.concat(hash), 512 + 160);
};

safe_add = function safe_add(x, y) {
  var lsw, msw;
  lsw = (x & 0xFFFF) + (y & 0xFFFF);
  msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
};

rol = function rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
};

str2binb = function str2binb(str) {
  var bin, i, mask;
  bin = Array();
  mask = (1 << chrsz) - 1;
  i = 0;
  while (i < str.length * chrsz) {
    bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << 32 - chrsz - i % 32;
    i += chrsz;
  }
  return bin;
};

binb2str = function binb2str(bin) {
  var i, mask, str;
  str = '';
  mask = (1 << chrsz) - 1;
  i = 0;
  while (i < bin.length * 32) {
    str += String.fromCharCode(bin[i >> 5] >>> 32 - chrsz - i % 32 & mask);
    i += chrsz;
  }
  return str;
};

binb2hex = function binb2hex(binarray) {
  var hex_tab, i, str;
  hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef';
  str = '';
  i = 0;
  while (i < binarray.length * 4) {
    str += hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 & 0xF);
    i++;
  }
  return str;
};

binb2b64 = function binb2b64(binarray) {
  var i, j, str, tab, triplet;
  tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  str = '';
  i = 0;
  while (i < binarray.length * 4) {
    triplet = (binarray[i >> 2] >> 8 * (3 - i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4) & 0xFF;
    j = 0;
    while (j < 4) {
      if (i * 8 + j * 6 > binarray.length * 32) {
        str += b64pad;
      } else {
        str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
      }
      j++;
    }
    i += 3;
  }
  return str;
};

// aardwulf systems
// This work is licensed under a Creative Commons License.
// http://www.aardwulf.com/tutor/base64/
encode64 = function encode64(input) {
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4, i, keyStr, output;
  keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '=';
  output = '';
  chr1 = void 0;
  chr2 = void 0;
  chr3 = '';
  enc1 = void 0;
  enc2 = void 0;
  enc3 = void 0;
  enc4 = '';
  i = 0;
  while (true) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = (chr1 & 3) << 4 | chr2 >> 4;
    enc3 = (chr2 & 15) << 2 | chr3 >> 6;
    enc4 = chr3 & 63;
    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    chr1 = chr2 = chr3 = '';
    enc1 = enc2 = enc3 = enc4 = '';
    if (!(i < input.length)) {
      break;
    }
  }
  return output;
};

// TITLE
// TempersFewGit v 2.1 (ISO 8601 Time/Date script)

// OBJECTIVE
// Javascript script to detect the time zone where a browser
// is and display the date and time in accordance with the
// ISO 8601 standard.

// AUTHOR
// John Walker
// http://321WebLiftOff.net
// jfwalker@ureach.com

// ENCOMIUM
// Thanks to Stephen Pugh for his help.

// CREATED
// 2000-09-15T09:42:53+01:00

// REFERENCES
// For more about ISO 8601 see:
// http://www.w3.org/TR/NOTE-datetime
// http://www.cl.cam.ac.uk/~mgk25/iso-time.html

// COPYRIGHT
// This script is Copyright  2000 JF Walker All Rights
// Reserved but may be freely used provided this colophon is
// included in full.

isodatetime = function isodatetime() {
  var day, diff, hour, hourUTC, hourdifference, millisecond, minute, minuteUTC, minutedifference, month, second, time, timezone, today, year;
  today = new Date();
  year = today.getYear();
  if (year < 2000) {
    year = year + 1900;
  }
  // http://onyx.idbsu.edu/~ipowell
  month = today.getMonth() + 1;
  day = today.getDate();
  hour = today.getHours();
  hourUTC = today.getUTCHours();
  diff = hour - hourUTC;
  hourdifference = Math.abs(diff);
  minute = today.getMinutes();
  minuteUTC = today.getUTCMinutes();
  minutedifference = void 0;
  second = today.getSeconds();
  millisecond = today.getMilliseconds();
  timezone = void 0;
  if (minute !== minuteUTC && minuteUTC < 30 && diff < 0) {
    hourdifference--;
  }
  if (minute !== minuteUTC && minuteUTC > 30 && diff > 0) {
    hourdifference--;
  }
  if (minute !== minuteUTC) {
    minutedifference = ':30';
  } else {
    minutedifference = ':00';
  }
  if (hourdifference < 10) {
    timezone = '0' + hourdifference + minutedifference;
  } else {
    timezone = '' + hourdifference + minutedifference;
  }
  if (diff < 0) {
    timezone = '-' + timezone;
  } else {
    timezone = '+' + timezone;
  }
  if (month <= 9) {
    month = '0' + month;
  }
  if (day <= 9) {
    day = '0' + day;
  }
  if (hour <= 9) {
    hour = '0' + hour;
  }
  if (minute <= 9) {
    minute = '0' + minute;
  }
  if (second <= 9) {
    second = '0' + second;
  }
  time = year + '-' + month + '-' + day + 'T' + hour + ':' + minute + ':' + second + '.' + millisecond + timezone;
  return time;
};

// (C) 2005 Victor R. Ruiz <victor*sixapart.com>
// Code to generate WSSE authentication header

// http://www.sixapart.com/pronet/docs/typepad_atom_api

// X-WSSE: UsernameToken Username="name", PasswordDigest="digest", Created="timestamp", Nonce="nonce"

//  * Username- The username that the user enters (the TypePad username).
//  * Nonce. A secure token generated anew for each HTTP request.
//  * Created. The ISO-8601 timestamp marking when Nonce was created.
//  * PasswordDigest. A SHA-1 digest of the Nonce, Created timestamp, and the password
//    that the user supplies, base64-encoded. In other words, this should be calculated
//    as: base64(sha1(Nonce . Created . Password))

wsse = function wsse(Password) {
  var Created, Nonce, PasswordDigest, nonceEncoded, r;
  PasswordDigest = void 0;
  Nonce = void 0;
  Created = void 0;
  nonceEncoded = void 0;
  r = new Array();
  Nonce = b64_sha1(isodatetime() + Math.floor(Math.random() * 1000).toString());
  nonceEncoded = encode64(Nonce);
  Created = isodatetime();
  PasswordDigest = b64_sha1(Nonce + Created + Password);
  r[0] = nonceEncoded;
  r[1] = Created;
  r[2] = PasswordDigest;
  return r;
};

module.exports.wsseHeader = function (Username, Password) {
  var header, w;
  w = wsse(Password);
  //        var header = 'UsernameToken Username="' + Username + '", PasswordDigest="' + w[2] + '", Created="' + w[1] + '", Nonce="' + w[0] + '"';
  header = 'UsernameToken Username="' + Username + '", PasswordDigest="' + w[2] + '", Nonce="' + w[0] + '", Created="' + w[1] + '"';
  return header;
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(55);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(364);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(370);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(369);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(28);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(29);

var _createClass3 = _interopRequireDefault(_createClass2);

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(10);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _jssha = __webpack_require__(450);

var _jssha2 = _interopRequireDefault(_jssha);

var _urlTemplate = __webpack_require__(50);

var _urlTemplate2 = _interopRequireDefault(_urlTemplate);

var _XHR = __webpack_require__(52);

var _XHR2 = _interopRequireDefault(_XHR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityTypesSingelton, ClientsSingelton, CollectionSingelton, ConfigsSingelton, GroupsSingelton, ServiceSingelton, XHR, addItem, deleteItem, updateCollection, updateItem;

XHR = new _XHR2.default();

deleteItem = function deleteItem(context, commit_type, item) {
  return new _promise2.default(function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(resolve, reject) {
      var e;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return XHR.delete(item);

            case 3:
              context.commit({
                type: commit_type,
                payload: item
              });
              return _context.abrupt('return', resolve(true));

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              e = _context.t0;
              console.log(e.response);
              return _context.abrupt('return', reject(e));

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 7]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

updateItem = function updateItem(context, commit_type, item) {
  return new _promise2.default(function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(resolve, reject) {
      var e;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.t0 = context;
              _context2.t1 = commit_type;
              _context2.next = 5;
              return XHR.put(item);

            case 5:
              _context2.t2 = _context2.sent;
              _context2.t3 = {
                type: _context2.t1,
                payload: _context2.t2
              };

              _context2.t0.commit.call(_context2.t0, _context2.t3);

              return _context2.abrupt('return', resolve(true));

            case 11:
              _context2.prev = 11;
              _context2.t4 = _context2['catch'](0);

              e = _context2.t4;
              console.log(e.response);
              return _context2.abrupt('return', reject(e));

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 11]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};

addItem = function addItem(context, commit_type, resource_url, item) {
  return new _promise2.default(function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(resolve, reject) {
      var e;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.t0 = context;
              _context3.t1 = commit_type;
              _context3.next = 5;
              return XHR.post(context.getters.resourceURL(resource_url), item);

            case 5:
              _context3.t2 = _context3.sent;
              _context3.t3 = {
                type: _context3.t1,
                payload: _context3.t2
              };

              _context3.t0.commit.call(_context3.t0, _context3.t3);

              return _context3.abrupt('return', resolve(true));

            case 11:
              _context3.prev = 11;
              _context3.t4 = _context3['catch'](0);

              e = _context3.t4;
              console.log(e.response);
              return _context3.abrupt('return', reject(e));

            case 16:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 11]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
};

updateCollection = function updateCollection(context, commit_type, collection) {
  return new _promise2.default(function (resolve, reject) {
    var promises;
    promises = collection.map(function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(item) {
        var e;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return XHR.put(item);

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](0);

                e = _context4.t0;
                return _context4.abrupt('return', console.log(e.response));

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6]]);
      }));

      return function (_x7) {
        return _ref4.apply(this, arguments);
      };
    }());
    return _promise2.default.all(promises).then(function () {
      context.commit({
        type: commit_type,
        payload: collection
      });
      return resolve(true);
    }).catch(function (e) {
      return reject(e);
    });
  });
};

CollectionSingelton = function () {
  //# Singeltons

  var CollectionSingelton = function () {
    function CollectionSingelton() {
      (0, _classCallCheck3.default)(this, CollectionSingelton);
    }

    (0, _createClass3.default)(CollectionSingelton, null, [{
      key: 'fetch',
      value: function fetch(context, resource_url, commit_type) {
        var _this = this;

        if (this.promise == null) {
          this.promise = new _promise2.default(function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(resolve, reject) {
              var e;
              return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;
                      _context5.t0 = context;
                      _context5.t1 = commit_type;
                      _context5.next = 5;
                      return XHR.get(context.getters.resourceURL(resource_url));

                    case 5:
                      _context5.t2 = _context5.sent;
                      _context5.t3 = {
                        type: _context5.t1,
                        payload: _context5.t2
                      };

                      _context5.t0.commit.call(_context5.t0, _context5.t3);

                      return _context5.abrupt('return', resolve(true));

                    case 11:
                      _context5.prev = 11;
                      _context5.t4 = _context5['catch'](0);

                      e = _context5.t4;
                      console.log(e);
                      return _context5.abrupt('return', reject(e));

                    case 16:
                    case 'end':
                      return _context5.stop();
                  }
                }
              }, _callee5, _this, [[0, 11]]);
            }));

            return function (_x8, _x9) {
              return _ref5.apply(this, arguments);
            };
          }());
        }
        return this.promise;
      }
    }]);
    return CollectionSingelton;
  }();

  ;

  CollectionSingelton.promise = null;

  return CollectionSingelton;
}();

ClientsSingelton = function () {
  function ClientsSingelton() {
    (0, _classCallCheck3.default)(this, ClientsSingelton);
  }

  (0, _createClass3.default)(ClientsSingelton, null, [{
    key: 'fetch',
    value: function fetch(context, resource_url, commit_type) {
      var _this2 = this;

      this.promise = new _promise2.default(function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(resolve, reject) {
          var e;
          return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.prev = 0;
                  _context6.t0 = context;
                  _context6.t1 = commit_type;
                  _context6.next = 5;
                  return XHR.get(context.getters.resourceURL(resource_url));

                case 5:
                  _context6.t2 = _context6.sent;
                  _context6.t3 = {
                    type: _context6.t1,
                    payload: _context6.t2
                  };

                  _context6.t0.commit.call(_context6.t0, _context6.t3);

                  return _context6.abrupt('return', resolve(true));

                case 11:
                  _context6.prev = 11;
                  _context6.t4 = _context6['catch'](0);

                  e = _context6.t4;
                  console.log(e);
                  return _context6.abrupt('return', reject(e));

                case 16:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this2, [[0, 11]]);
        }));

        return function (_x10, _x11) {
          return _ref6.apply(this, arguments);
        };
      }());
      return this.promise;
    }
  }]);
  return ClientsSingelton;
}();

GroupsSingelton = function (_CollectionSingelton) {
  (0, _inherits3.default)(GroupsSingelton, _CollectionSingelton);

  function GroupsSingelton() {
    (0, _classCallCheck3.default)(this, GroupsSingelton);
    return (0, _possibleConstructorReturn3.default)(this, (GroupsSingelton.__proto__ || (0, _getPrototypeOf2.default)(GroupsSingelton)).apply(this, arguments));
  }

  return GroupsSingelton;
}(CollectionSingelton);

ConfigsSingelton = function (_CollectionSingelton2) {
  (0, _inherits3.default)(ConfigsSingelton, _CollectionSingelton2);

  function ConfigsSingelton() {
    (0, _classCallCheck3.default)(this, ConfigsSingelton);
    return (0, _possibleConstructorReturn3.default)(this, (ConfigsSingelton.__proto__ || (0, _getPrototypeOf2.default)(ConfigsSingelton)).apply(this, arguments));
  }

  return ConfigsSingelton;
}(CollectionSingelton);

ActivityTypesSingelton = function (_CollectionSingelton3) {
  (0, _inherits3.default)(ActivityTypesSingelton, _CollectionSingelton3);

  function ActivityTypesSingelton() {
    (0, _classCallCheck3.default)(this, ActivityTypesSingelton);
    return (0, _possibleConstructorReturn3.default)(this, (ActivityTypesSingelton.__proto__ || (0, _getPrototypeOf2.default)(ActivityTypesSingelton)).apply(this, arguments));
  }

  return ActivityTypesSingelton;
}(CollectionSingelton);

ServiceSingelton = function () {
  var promise;

  var ServiceSingelton = function () {
    function ServiceSingelton() {
      (0, _classCallCheck3.default)(this, ServiceSingelton);
    }

    (0, _createClass3.default)(ServiceSingelton, null, [{
      key: 'fetch',
      value: function fetch(context) {
        var _this6 = this;

        if (promise == null) {
          promise = new _promise2.default(function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(resolve, reject) {
              var e;
              return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.prev = 0;
                      _context7.t0 = context;
                      _context7.next = 4;
                      return XHR.get('/api/');

                    case 4:
                      _context7.t1 = _context7.sent;
                      _context7.t2 = {
                        type: 'SET_RESOURCES',
                        resources: _context7.t1
                      };

                      _context7.t0.commit.call(_context7.t0, _context7.t2);

                      return _context7.abrupt('return', resolve(true));

                    case 10:
                      _context7.prev = 10;
                      _context7.t3 = _context7['catch'](0);

                      e = _context7.t3;
                      console.log(e);
                      return _context7.abrupt('return', reject(e));

                    case 15:
                    case 'end':
                      return _context7.stop();
                  }
                }
              }, _callee7, _this6, [[0, 10]]);
            }));

            return function (_x12, _x13) {
              return _ref7.apply(this, arguments);
            };
          }());
        }
        return promise;
      }
    }]);
    return ServiceSingelton;
  }();

  ;

  promise = null;

  return ServiceSingelton;
}();

exports.default = {
  xhrIsLoading: function xhrIsLoading(context, status) {
    return context.commit({
      type: 'XHR_IS_LOADING',
      xhr_is_loading: status
    });
  },
  showDialog: function showDialog(context, dialog) {
    return context.commit({
      type: 'SHOW_DIALOG',
      dialog: dialog
    });
  },
  working: function working(context, status) {
    return context.commit({
      type: 'WORKING',
      xhr_is_loading: status
    });
  },
  getServices: function getServices(context) {
    return ServiceSingelton.fetch(context);
  },
  getConfigs: function getConfigs(context) {
    return ConfigsSingelton.fetch(context, 'config.list', 'SET_CONFIGS');
  },
  getGroups: function getGroups(context) {
    return GroupsSingelton.fetch(context, 'client_property_group.list', 'SET_CPROP_GROUPS');
  },
  getActivityTypes: function getActivityTypes(context) {
    return ActivityTypesSingelton.fetch(context, 'activity_type.list', 'SET_ACTIVITY_TYPES');
  },
  getActivities: function getActivities(context, filter) {
    var _this7 = this;

    return new _promise2.default(function () {
      var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(resolve, reject) {
        var e;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.t0 = context;
                _context8.next = 4;
                return XHR.get(context.getters.resourceURL('activity.list'), filter);

              case 4:
                _context8.t1 = _context8.sent;
                _context8.t2 = {
                  type: 'SET_ACTIVITIES',
                  payload: _context8.t1
                };

                _context8.t0.commit.call(_context8.t0, _context8.t2);

                return _context8.abrupt('return', resolve(true));

              case 10:
                _context8.prev = 10;
                _context8.t3 = _context8['catch'](0);

                e = _context8.t3;
                console.log(e);
                return _context8.abrupt('return', reject(e));

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this7, [[0, 10]]);
      }));

      return function (_x14, _x15) {
        return _ref8.apply(this, arguments);
      };
    }());
  },
  //##### ADD
  addGroup: function addGroup(context, evt) {
    return addItem(context, 'ADD_CPROP_GROUP', 'client_property_groups.post', evt);
  },
  addProperty: function addProperty(context, evt) {
    return addItem(context, 'ADD_CPROP', 'client_property_definitions.post', evt);
  },
  addOption: function addOption(context, evt) {
    return addItem(context, 'ADD_OPTION', 'client_property_options.post', evt);
  },
  addActivity: function addActivity(context, evt) {
    return addItem(context, 'ADD_ACTIVITY', 'activity.post', evt);
  },
  addActivityType: function addActivityType(context, evt) {
    return addItem(context, 'ADD_ACTIVITY_TYPE', 'activity_type.post', evt);
  },
  //##### UPDATE
  updateActivity: function updateActivity(context, activity) {
    if ('activity_type_label' in activity) {
      delete activity.activity_type_label;
    }
    return updateItem(context, 'UPDATE_ACTIVITY', activity);
  },
  updateActivityType: function updateActivityType(context, type) {
    return updateItem(context, 'UPDATE_ACTIVITY_TYPE', type);
  },
  updateConfig: function updateConfig(context, config) {
    return updateItem(context, 'UPDATE_CONFIG', config);
  },
  updateGroup: function updateGroup(context, group) {
    return updateItem(context, 'UPDATE_CPROP_GROUP', group);
  },
  updateOption: function updateOption(context, option) {
    return updateItem(context, 'UPDATE_OPTION', option);
  },
  updateProperty: function updateProperty(context, prop) {
    return updateItem(context, 'UPDATE_CPROP', prop);
  },
  //##### DELETE
  deleteActivity: function deleteActivity(context, evt) {
    return deleteItem(context, 'DELETE_ACTIVITY', evt);
  },
  deleteGroup: function deleteGroup(context, evt) {
    return deleteItem(context, 'DELETE_CPROP_GROUP', evt);
  },
  deleteProperty: function deleteProperty(context, evt) {
    return deleteItem(context, 'DELETE_CPROP', evt);
  },
  deleteOption: function deleteOption(context, evt) {
    return deleteItem(context, 'DELETE_OPTION', evt);
  },
  deleteActivityType: function deleteActivityType(context, type) {
    return new _promise2.default(function () {
      var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(resolve, reject) {
        var e;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return XHR.delete(type);

              case 3:
                context.commit({
                  type: 'DELETE_ACTIVITY_TYPE',
                  activity_type: type
                });
                return _context9.abrupt('return', resolve(true));

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9['catch'](0);

                e = _context9.t0;
                console.log(e.response);
                return _context9.abrupt('return', reject(e));

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));

      return function (_x16, _x17) {
        return _ref9.apply(this, arguments);
      };
    }());
  },
  //##### UPDATE COLLECTIONS
  updateGroups: function updateGroups(context, e) {
    return new _promise2.default(function (resolve, reject) {
      var promises;
      promises = e.groups.map(function () {
        var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(g) {
          return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.prev = 0;
                  _context10.next = 3;
                  return XHR.put(g);

                case 3:
                  return _context10.abrupt('return', _context10.sent);

                case 6:
                  _context10.prev = 6;
                  _context10.t0 = _context10['catch'](0);

                  e = _context10.t0;
                  return _context10.abrupt('return', console.log(e.response));

                case 10:
                case 'end':
                  return _context10.stop();
              }
            }
          }, _callee10, this, [[0, 6]]);
        }));

        return function (_x18) {
          return _ref10.apply(this, arguments);
        };
      }());
      return _promise2.default.all(promises).then(function () {
        context.commit({
          type: 'UPDATE_GROUPS',
          groups: e.groups
        });
        return resolve(true);
      }).catch(function (e) {
        return reject(e);
      });
    });
  },
  updateProps: function updateProps(context, e) {
    return new _promise2.default(function (resolve, reject) {
      var promises;
      promises = e.props.map(function () {
        var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(p) {
          return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.prev = 0;
                  _context11.next = 3;
                  return XHR.put(p);

                case 3:
                  return _context11.abrupt('return', _context11.sent);

                case 6:
                  _context11.prev = 6;
                  _context11.t0 = _context11['catch'](0);

                  e = _context11.t0;
                  return _context11.abrupt('return', console.log(e.response));

                case 10:
                case 'end':
                  return _context11.stop();
              }
            }
          }, _callee11, this, [[0, 6]]);
        }));

        return function (_x19) {
          return _ref11.apply(this, arguments);
        };
      }());
      return _promise2.default.all(promises).then(function () {
        context.commit({
          type: 'UPDATE_PROPS',
          group: e.group,
          props: e.props
        });
        return resolve(true);
      }).catch(function (e) {
        return reject(e);
      });
    });
  },
  updateOptions: function updateOptions(context, e) {
    return new _promise2.default(function (resolve, reject) {
      var promises;
      promises = e.options.map(function () {
        var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(o) {
          return _regenerator2.default.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.prev = 0;
                  _context12.next = 3;
                  return XHR.put(o);

                case 3:
                  return _context12.abrupt('return', _context12.sent);

                case 6:
                  _context12.prev = 6;
                  _context12.t0 = _context12['catch'](0);

                  e = _context12.t0;
                  return _context12.abrupt('return', console.log(e.response));

                case 10:
                case 'end':
                  return _context12.stop();
              }
            }
          }, _callee12, this, [[0, 6]]);
        }));

        return function (_x20) {
          return _ref12.apply(this, arguments);
        };
      }());
      return _promise2.default.all(promises).then(function () {
        context.commit({
          type: 'UPDATE_OPTIONS',
          group: e.group,
          props: e.prop,
          options: e.options
        });
        return resolve(true);
      }).catch(function (e) {
        return reject(e);
      });
    });
  },
  updateActivityTypes: function updateActivityTypes(context, e) {
    return new _promise2.default(function (resolve, reject) {
      var promises;
      promises = e.types.map(function () {
        var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(g) {
          return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.prev = 0;
                  _context13.next = 3;
                  return XHR.put(g);

                case 3:
                  return _context13.abrupt('return', _context13.sent);

                case 6:
                  _context13.prev = 6;
                  _context13.t0 = _context13['catch'](0);

                  e = _context13.t0;
                  return _context13.abrupt('return', console.log(e.response));

                case 10:
                case 'end':
                  return _context13.stop();
              }
            }
          }, _callee13, this, [[0, 6]]);
        }));

        return function (_x21) {
          return _ref13.apply(this, arguments);
        };
      }());
      return _promise2.default.all(promises).then(function () {
        context.commit({
          type: 'UPDATE_ACTIVITY_TYPES',
          types: e.types
        });
        return resolve(true);
      }).catch(function (e) {
        return reject(e);
      });
    });
  },
  //##### CLIENT
  getClientList: function getClientList(context) {
    return ClientsSingelton.fetch(context, 'client.list', 'SET_CLIENT_LIST');
  },
  checkClientId: function checkClientId(context, mutation) {
    return new _promise2.default(function () {
      var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(resolve, reject) {
        var clients, e, result;
        return _regenerator2.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(mutation.id !== null)) {
                  _context14.next = 16;
                  break;
                }

                _context14.prev = 1;
                _context14.next = 4;
                return XHR.get(context.getters.resourceURL('client.list'), {
                  id: mutation.id
                });

              case 4:
                result = _context14.sent;

                clients = result.getEmbeds('clients');
                return _context14.abrupt('return', resolve(clients.length === 0 || mutation.uid === clients[0].uid));

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14['catch'](1);

                e = _context14.t0;
                console.log(e);
                return _context14.abrupt('return', reject(e));

              case 14:
                _context14.next = 17;
                break;

              case 16:
                return _context14.abrupt('return', resolve(true));

              case 17:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[1, 9]]);
      }));

      return function (_x22, _x23) {
        return _ref14.apply(this, arguments);
      };
    }());
  },
  selectClient: function selectClient(context, client) {
    return new _promise2.default(function () {
      var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15(resolve, reject) {
        var e;
        return _regenerator2.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.t0 = context;
                _context15.next = 4;
                return XHR.get(client.getLink('self').href);

              case 4:
                _context15.t1 = _context15.sent;
                _context15.t2 = {
                  type: 'SELECT_CLIENT',
                  selected_client: _context15.t1
                };
                _context15.t3 = resolve(true);
                return _context15.abrupt('return', _context15.t0.commit.call(_context15.t0, _context15.t2, _context15.t3));

              case 10:
                _context15.prev = 10;
                _context15.t4 = _context15['catch'](0);

                e = _context15.t4;
                console.log(e.response);
                return _context15.abrupt('return', reject(e));

              case 15:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 10]]);
      }));

      return function (_x24, _x25) {
        return _ref15.apply(this, arguments);
      };
    }());
  },
  setClientNote: function setClientNote(context, note) {
    console.log(note);
    return context.commit({
      type: 'SET_CLIENT_NOTE',
      note: note
    });
  },
  newClient: function newClient(context, mutation) {
    return context.commit('NEW_CLIENT');
  },
  saveClient: function saveClient(context, mutation) {
    var client, original_prop_values;

    var _mutation = (0, _slicedToArray3.default)(mutation, 2);

    client = _mutation[0];
    original_prop_values = _mutation[1];

    return new _promise2.default(function () {
      var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18(resolve, reject) {
        var e, is_existing_client, promises, properties;
        return _regenerator2.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                is_existing_client = client.getLink('self') != null;

                if (!is_existing_client) {
                  _context18.next = 19;
                  break;
                }

                _context18.prev = 2;
                _context18.next = 5;
                return XHR.put(client);

              case 5:
                context.dispatch('getClientList');
                context.commit({
                  type: 'SELECT_CLIENT',
                  selected_client: client
                });
                properties = client.getEmbeds('client_property');
                promises = properties.map(function () {
                  var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(p) {
                    var e;
                    return _regenerator2.default.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            if (!(p.value !== original_prop_values[p.property_uid])) {
                              _context16.next = 13;
                              break;
                            }

                            console.log(p);
                            _context16.prev = 2;
                            _context16.next = 5;
                            return XHR.put(p);

                          case 5:
                            return _context16.abrupt('return', _context16.sent);

                          case 8:
                            _context16.prev = 8;
                            _context16.t0 = _context16['catch'](2);

                            e = _context16.t0;
                            console.log(e.response);
                            return _context16.abrupt('return', reject(e));

                          case 13:
                          case 'end':
                            return _context16.stop();
                        }
                      }
                    }, _callee16, this, [[2, 8]]);
                  }));

                  return function (_x28) {
                    return _ref17.apply(this, arguments);
                  };
                }());
                return _context18.abrupt('return', _promise2.default.all(promises).then(function () {
                  context.dispatch('getClientList');
                  return resolve(true);
                }).catch(function (e) {
                  return reject(e);
                }));

              case 12:
                _context18.prev = 12;
                _context18.t0 = _context18['catch'](2);

                e = _context18.t0;
                console.log(e);
                return _context18.abrupt('return', reject(e));

              case 17:
                _context18.next = 33;
                break;

              case 19:
                _context18.prev = 19;

                properties = client.getEmbeds('client_property');
                _context18.next = 23;
                return XHR.post(context.getters.resourceURL('client.post'), client);

              case 23:
                client = _context18.sent;

                promises = properties.map(function () {
                  var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17(p) {
                    return _regenerator2.default.wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            p.client_uid = client.uid;
                            _context17.prev = 1;
                            _context17.next = 4;
                            return XHR.post(context.getters.resourceURL('client_property.post'), p);

                          case 4:
                            p = _context17.sent;
                            return _context17.abrupt('return', client.addEmbed('client_property', p));

                          case 8:
                            _context17.prev = 8;
                            _context17.t0 = _context17['catch'](1);

                            e = _context17.t0;
                            console.log(e.response);
                            return _context17.abrupt('return', reject(e));

                          case 13:
                          case 'end':
                            return _context17.stop();
                        }
                      }
                    }, _callee17, this, [[1, 8]]);
                  }));

                  return function (_x29) {
                    return _ref18.apply(this, arguments);
                  };
                }());
                return _context18.abrupt('return', _promise2.default.all(promises).then(function () {
                  context.commit({
                    type: 'SELECT_CLIENT',
                    selected_client: client
                  });
                  context.dispatch('getClientList');
                  return resolve(true);
                }));

              case 28:
                _context18.prev = 28;
                _context18.t1 = _context18['catch'](19);

                e = _context18.t1;
                console.log(e.response);
                return _context18.abrupt('return', reject(e));

              case 33:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this, [[2, 12], [19, 28]]);
      }));

      return function (_x26, _x27) {
        return _ref16.apply(this, arguments);
      };
    }());
  },
  login: function login(context, user) {
    return new _promise2.default(function () {
      var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19(resolve, reject) {
        var e, password_hash, shaObj;
        return _regenerator2.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                shaObj = new _jssha2.default('SHA-512', 'TEXT');
                shaObj.update(user.password);
                password_hash = shaObj.getHash('HEX');
                XHR.setUser(user.username, password_hash);
                _context19.prev = 4;
                _context19.next = 7;
                return XHR.get(context.getters.resourceURL('user.login'));

              case 7:
                user = _context19.sent;

                user.password = password_hash;
                user.is_logged_in = true;
                context.commit({
                  type: 'UPDATE_USER',
                  user: user
                });
                return _context19.abrupt('return', resolve(true));

              case 14:
                _context19.prev = 14;
                _context19.t0 = _context19['catch'](4);

                e = _context19.t0;
                console.log(e.response);
                context.commit({
                  type: 'RESET_USER'
                });
                XHR.setUser(null, null);
                throw e;

              case 21:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this, [[4, 14]]);
      }));

      return function (_x30, _x31) {
        return _ref19.apply(this, arguments);
      };
    }());
  },
  refresh_login: function refresh_login(context, user) {
    return XHR.setUser(user.username, user.password);
  },
  logout: function logout(context) {
    XHR.setUser(null, null);
    return context.commit({
      type: 'RESET_USER'
    });
  }
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlTemplate = __webpack_require__(50);

var _urlTemplate2 = _interopRequireDefault(_urlTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  isLoaded: function isLoaded(state) {
    return state.is_loaded;
  },
  getHref: function getHref(state) {
    return function (ref) {
      return state.endpoints.getLink(ref).href;
    };
  },
  getURLTemplate: function getURLTemplate(state) {
    return function (ref) {
      return _urlTemplate2.default.parse(state.endpoints.getLink(ref).href);
    };
  },
  resourceURL: function resourceURL(state) {
    return function (type) {
      try {
        return state.resources.getLink(type).href;
      } catch (error) {
        throw 'Resource of type: "' + type + '" doesn\'t exist!';
      }
    };
  }
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _HALSONResource = __webpack_require__(37);

var _HALSONResource2 = _interopRequireDefault(_HALSONResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Client, getOption, getOptionParent, getProperty, moveElement;

Client = function Client() {
  return (0, _HALSONResource2.default)({
    uid: null,
    id: null,
    start: null,
    end: null,
    gender: null,
    year: null,
    note: {
      ops: []
    }
  });
};

moveElement = function moveElement(array, old_index, new_index) {
  var el, i, idx, incr, item, len, target;
  target = array[old_index];
  incr = (new_index - old_index) / Math.abs(new_index - old_index);
  el = old_index;
  while (el !== new_index) {
    array[el] = array[el + incr];
    el += incr;
  }
  array[new_index] = target;
  for (idx = i = 0, len = array.length; i < len; idx = ++i) {
    item = array[idx];
    item.sortorder = idx;
  }
  return array;
};

getProperty = function getProperty(state, mutation) {
  return state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.payload.client_property_group_id).getEmbedByRelAndUID('client_property_definition', mutation.payload.uid);
};

getOption = function getOption(state, mutation) {
  return state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.payload.property_group_uid).getEmbedByRelAndUID('client_property_definition', mutation.payload.property_uid).getEmbedByRelAndUID('client_property_option', mutation.payload.uid);
};

getOptionParent = function getOptionParent(state, mutation) {
  return state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.payload.property_group_uid).getEmbedByRelAndUID('client_property_definition', mutation.payload.property_uid);
};

exports.default = {
  'SHOW_DIALOG': function SHOW_DIALOG(state, mutation) {
    return _vue2.default.set(state, 'dialog', mutation.dialog);
  },
  'SELECT_CLIENT': function SELECT_CLIENT(state, mutation) {
    return state.selected_client = mutation.selected_client;
  },
  'NEW_CLIENT': function NEW_CLIENT(state, mutation) {
    return state.selected_client = new Client();
  },
  'XHR_IS_LOADING': function XHR_IS_LOADING(state, mutation) {
    return state.xhr_is_loading = mutation.xhr_is_loading;
  },
  'WORKING': function WORKING(state, mutation) {
    return state.working = mutation.working;
  },
  'SET_ACTIVITIES': function SET_ACTIVITIES(state, mutation) {
    state.activities = mutation.payload;
    return state.are_loaded.activities = true;
  },
  'SET_ACTIVITY_TYPES': function SET_ACTIVITY_TYPES(state, mutation) {
    state.activity_types = mutation.payload;
    return state.are_loaded.activity_types = true;
  },
  'SET_CLIENT_LIST': function SET_CLIENT_LIST(state, mutation) {
    state.client_list = mutation.payload;
    return state.are_loaded.client_list = true;
  },
  'SET_CLIENT_NOTE': function SET_CLIENT_NOTE(state, mutation) {
    return state.selected_client.note = mutation.note;
  },
  'SET_CONFIGS': function SET_CONFIGS(state, mutation) {
    return state.configs = mutation.payload;
  },
  'SET_CPROP_GROUPS': function SET_CPROP_GROUPS(state, mutation) {
    state.cprop_groups = mutation.payload;
    state.are_loaded.groups = true;
    return state.are_loaded.configs = true;
  },
  'SET_RESOURCES': function SET_RESOURCES(state, mutation) {
    state.resources = mutation.resources;
    return state.are_loaded.resources = true;
  },
  'ADD_ACTIVITY': function ADD_ACTIVITY(state, mutation) {
    return state.activities.addEmbed('activities', mutation.payload);
  },
  'ADD_ACTIVITY_TYPE': function ADD_ACTIVITY_TYPE(state, mutation) {
    return state.activity_types.addEmbed('activity_type', mutation.payload);
  },
  'ADD_CPROP': function ADD_CPROP(state, mutation) {
    return state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.payload.client_property_group_id).addEmbed('client_property_definition', mutation.payload);
  },
  'ADD_CPROP_GROUP': function ADD_CPROP_GROUP(state, mutation) {
    return state.cprop_groups.addEmbed('client_property_groups', mutation.payload);
  },
  'ADD_OPTION': function ADD_OPTION(state, mutation) {
    return getOptionParent(state, mutation).addEmbed('client_property_option', mutation.payload);
  },
  'DELETE_ACTIVITY': function DELETE_ACTIVITY(state, mutation) {
    return state.activities.removeEmbedByRelAndUID('activities', mutation.payload.uid);
  },
  'DELETE_ACTIVITY_TYPE': function DELETE_ACTIVITY_TYPE(state, mutation) {
    return state.activity_types.removeEmbedByRelAndUID('activity_type', mutation.activity_type.uid);
  },
  'DELETE_CPROP': function DELETE_CPROP(state, mutation) {
    return state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.payload.client_property_group_id).removeEmbedByRelAndUID('client_property_definition', mutation.payload.uid);
  },
  'DELETE_CPROP_GROUP': function DELETE_CPROP_GROUP(state, mutation) {
    return state.cprop_groups.removeEmbedByRelAndUID('client_property_groups', mutation.payload.uid);
  },
  'DELETE_OPTION': function DELETE_OPTION(state, mutation) {
    return getOptionParent(state, mutation).removeEmbedByRelAndUID('client_property_option', mutation.payload.uid);
  },
  'UPDATE_ACTIVITY': function UPDATE_ACTIVITY(state, mutation) {
    var activity;
    activity = state.activities.getEmbedByRelAndUID('activities', mutation.payload.uid);
    return _.assign(activity, mutation.payload);
  },
  'UPDATE_ACTIVITY_TYPE': function UPDATE_ACTIVITY_TYPE(state, mutation) {
    var type;
    type = state.activity_types.getEmbedByRelAndUID('activity_type', mutation.payload.uid);
    return _.assign(type, mutation.payload);
  },
  'UPDATE_ACTIVITY_TYPES': function UPDATE_ACTIVITY_TYPES(state, mutation) {
    state.activity_types.removeEmbeds('activity_type');
    return mutation.types.map(function (g) {
      return state.activity_types.addEmbed('activity_type', g);
    });
  },
  'UPDATE_GROUPS': function UPDATE_GROUPS(state, mutation) {
    state.cprop_groups.removeEmbeds('client_property_groups');
    return mutation.groups.map(function (g) {
      return state.cprop_groups.addEmbed('client_property_groups', g);
    });
  },
  'UPDATE_CPROP_GROUP': function UPDATE_CPROP_GROUP(state, mutation) {
    var group;
    group = state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.payload.uid);
    return _.assign(group, mutation.payload);
  },
  'UPDATE_CPROP': function UPDATE_CPROP(state, mutation) {
    var prop;
    prop = getProperty(state, mutation);
    return _.assign(prop, mutation.payload);
  },
  'UPDATE_PROPS': function UPDATE_PROPS(state, mutation) {
    var group, i, len, p, ref, results;
    console.log(mutation);
    group = state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.group.uid);
    group.removeEmbeds('client_property_definition');
    ref = mutation.props;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      p = ref[i];
      results.push(group.addEmbed('client_property_definition', p));
    }
    return results;
  },
  'UPDATE_OPTIONS': function UPDATE_OPTIONS(state, mutation) {
    var i, len, o, prop, ref, results;
    prop = getOptionParent(state, mutation);
    prop.removeEmbeds('client_property_option');
    ref = mutation.options;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      o = ref[i];
      results.push(prop.addEmbed('client_property_option', o));
    }
    return results;
  },
  'UPDATE_OPTION': function UPDATE_OPTION(state, mutation) {
    var option;
    option = getOption(state, mutation);
    return _.assign(option, mutation.payload);
  },
  'UPDATE_CONFIG': function UPDATE_CONFIG(state, mutation) {
    var config;
    config = state.configs.getEmbedByRelAndUID('config', mutation.payload.key);
    return _.assign(config, mutation.payload);
  },
  'REORDER_CPROP_GROUP': function REORDER_CPROP_GROUP(state, mutation) {
    var groups;
    groups = state.cprop_groups;
    return moveElement(groups, mutation.old_index, mutation.new_index);
  },
  'REORDER_PROPERTY': function REORDER_PROPERTY(state, mutation) {
    var properties;
    properties = state.cprop_groups.getEmbedByRelAndUID('client_property_groups', mutation.group_uid).getEmbeds('client_property_definition');
    return moveElement(properties, mutation.old_index, mutation.new_index);
  },
  'REORDER_OPTION': function REORDER_OPTION(state, mutation) {
    var options;
    options = state.cprop_groups[mutation.group_index].getEmbeds('client_property_definition')[mutation.property_index].getEmbeds('client_property_option');
    return moveElement(options, mutation.old_index, mutation.new_index);
  },
  'UPDATE_USER': function UPDATE_USER(state, mutation) {
    state.user = mutation.user;
    sessionStorage.first_name = state.user.first_name;
    sessionStorage.last_name = state.user.last_name;
    sessionStorage.username = state.user.username;
    sessionStorage.password = state.user.password;
    return sessionStorage.is_logged_in = state.user.is_logged_in;
  },
  'RESET_USER': function RESET_USER(state) {
    state.user = {
      first_name: null,
      last_name: null,
      username: null,
      password: null,
      is_logged_in: false
    };
    state.client_list = [];
    sessionStorage.first_name = null;
    sessionStorage.last_name = null;
    sessionStorage.username = null;
    sessionStorage.password = null;
    return sessionStorage.is_logged_in = false;
  }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HALSONResource = __webpack_require__(37);

var _HALSONResource2 = _interopRequireDefault(_HALSONResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Client;

Client = function Client() {
  return (0, _HALSONResource2.default)({
    uid: null,
    id: null,
    start: null,
    end: null,
    gender: null,
    year: null,
    note: {
      ops: []
    }
  });
};

exports.default = {
  activities: (0, _HALSONResource2.default)(null),
  activity_types: (0, _HALSONResource2.default)(null),
  are_loaded: {
    activities: false,
    activity_types: false,
    client_list: false,
    configs: false,
    groups: false,
    resources: false
  },
  client_list: (0, _HALSONResource2.default)(null),
  configs: (0, _HALSONResource2.default)(null),
  cprop_groups: (0, _HALSONResource2.default)(null),
  dialog: '',
  resources: null,
  selected_client: new Client(),
  version: "1.4.0",
  working: false,
  xhr_is_loading: false,
  user: {
    first_name: sessionStorage.getItem('first_name'),
    last_name: sessionStorage.getItem('last_name'),
    username: sessionStorage.getItem('username'),
    password: sessionStorage.getItem('password'),
    is_logged_in: sessionStorage.getItem('is_logged_in') === "true" || false
  }
};

/***/ }),
/* 299 */,
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 111,
	"./af.js": 111,
	"./ar": 118,
	"./ar-dz": 112,
	"./ar-dz.js": 112,
	"./ar-kw": 113,
	"./ar-kw.js": 113,
	"./ar-ly": 114,
	"./ar-ly.js": 114,
	"./ar-ma": 115,
	"./ar-ma.js": 115,
	"./ar-sa": 116,
	"./ar-sa.js": 116,
	"./ar-tn": 117,
	"./ar-tn.js": 117,
	"./ar.js": 118,
	"./az": 119,
	"./az.js": 119,
	"./be": 120,
	"./be.js": 120,
	"./bg": 121,
	"./bg.js": 121,
	"./bm": 122,
	"./bm.js": 122,
	"./bn": 123,
	"./bn.js": 123,
	"./bo": 124,
	"./bo.js": 124,
	"./br": 125,
	"./br.js": 125,
	"./bs": 126,
	"./bs.js": 126,
	"./ca": 127,
	"./ca.js": 127,
	"./cs": 128,
	"./cs.js": 128,
	"./cv": 129,
	"./cv.js": 129,
	"./cy": 130,
	"./cy.js": 130,
	"./da": 131,
	"./da.js": 131,
	"./de": 134,
	"./de-at": 132,
	"./de-at.js": 132,
	"./de-ch": 133,
	"./de-ch.js": 133,
	"./de.js": 134,
	"./dv": 135,
	"./dv.js": 135,
	"./el": 136,
	"./el.js": 136,
	"./en-au": 137,
	"./en-au.js": 137,
	"./en-ca": 138,
	"./en-ca.js": 138,
	"./en-gb": 139,
	"./en-gb.js": 139,
	"./en-ie": 140,
	"./en-ie.js": 140,
	"./en-nz": 141,
	"./en-nz.js": 141,
	"./eo": 142,
	"./eo.js": 142,
	"./es": 145,
	"./es-do": 143,
	"./es-do.js": 143,
	"./es-us": 144,
	"./es-us.js": 144,
	"./es.js": 145,
	"./et": 146,
	"./et.js": 146,
	"./eu": 147,
	"./eu.js": 147,
	"./fa": 148,
	"./fa.js": 148,
	"./fi": 149,
	"./fi.js": 149,
	"./fo": 150,
	"./fo.js": 150,
	"./fr": 153,
	"./fr-ca": 151,
	"./fr-ca.js": 151,
	"./fr-ch": 152,
	"./fr-ch.js": 152,
	"./fr.js": 153,
	"./fy": 154,
	"./fy.js": 154,
	"./gd": 155,
	"./gd.js": 155,
	"./gl": 156,
	"./gl.js": 156,
	"./gom-latn": 157,
	"./gom-latn.js": 157,
	"./gu": 158,
	"./gu.js": 158,
	"./he": 159,
	"./he.js": 159,
	"./hi": 160,
	"./hi.js": 160,
	"./hr": 161,
	"./hr.js": 161,
	"./hu": 162,
	"./hu.js": 162,
	"./hy-am": 163,
	"./hy-am.js": 163,
	"./id": 164,
	"./id.js": 164,
	"./is": 165,
	"./is.js": 165,
	"./it": 166,
	"./it.js": 166,
	"./ja": 167,
	"./ja.js": 167,
	"./jv": 168,
	"./jv.js": 168,
	"./ka": 169,
	"./ka.js": 169,
	"./kk": 170,
	"./kk.js": 170,
	"./km": 171,
	"./km.js": 171,
	"./kn": 172,
	"./kn.js": 172,
	"./ko": 173,
	"./ko.js": 173,
	"./ky": 174,
	"./ky.js": 174,
	"./lb": 175,
	"./lb.js": 175,
	"./lo": 176,
	"./lo.js": 176,
	"./lt": 177,
	"./lt.js": 177,
	"./lv": 178,
	"./lv.js": 178,
	"./me": 179,
	"./me.js": 179,
	"./mi": 180,
	"./mi.js": 180,
	"./mk": 181,
	"./mk.js": 181,
	"./ml": 182,
	"./ml.js": 182,
	"./mr": 183,
	"./mr.js": 183,
	"./ms": 185,
	"./ms-my": 184,
	"./ms-my.js": 184,
	"./ms.js": 185,
	"./my": 186,
	"./my.js": 186,
	"./nb": 187,
	"./nb.js": 187,
	"./ne": 188,
	"./ne.js": 188,
	"./nl": 190,
	"./nl-be": 189,
	"./nl-be.js": 189,
	"./nl.js": 190,
	"./nn": 191,
	"./nn.js": 191,
	"./pa-in": 192,
	"./pa-in.js": 192,
	"./pl": 193,
	"./pl.js": 193,
	"./pt": 195,
	"./pt-br": 194,
	"./pt-br.js": 194,
	"./pt.js": 195,
	"./ro": 196,
	"./ro.js": 196,
	"./ru": 197,
	"./ru.js": 197,
	"./sd": 198,
	"./sd.js": 198,
	"./se": 199,
	"./se.js": 199,
	"./si": 200,
	"./si.js": 200,
	"./sk": 201,
	"./sk.js": 201,
	"./sl": 202,
	"./sl.js": 202,
	"./sq": 203,
	"./sq.js": 203,
	"./sr": 205,
	"./sr-cyrl": 204,
	"./sr-cyrl.js": 204,
	"./sr.js": 205,
	"./ss": 206,
	"./ss.js": 206,
	"./sv": 207,
	"./sv.js": 207,
	"./sw": 208,
	"./sw.js": 208,
	"./ta": 209,
	"./ta.js": 209,
	"./te": 210,
	"./te.js": 210,
	"./tet": 211,
	"./tet.js": 211,
	"./th": 212,
	"./th.js": 212,
	"./tl-ph": 213,
	"./tl-ph.js": 213,
	"./tlh": 214,
	"./tlh.js": 214,
	"./tr": 215,
	"./tr.js": 215,
	"./tzl": 216,
	"./tzl.js": 216,
	"./tzm": 218,
	"./tzm-latn": 217,
	"./tzm-latn.js": 217,
	"./tzm.js": 218,
	"./uk": 219,
	"./uk.js": 219,
	"./ur": 220,
	"./ur.js": 220,
	"./uz": 222,
	"./uz-latn": 221,
	"./uz-latn.js": 221,
	"./uz.js": 222,
	"./vi": 223,
	"./vi.js": 223,
	"./x-pseudo": 224,
	"./x-pseudo.js": 224,
	"./yo": 225,
	"./yo.js": 225,
	"./zh-cn": 226,
	"./zh-cn.js": 226,
	"./zh-hk": 227,
	"./zh-hk.js": 227,
	"./zh-tw": 228,
	"./zh-tw.js": 228
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338;

/***/ }),
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(321)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(514),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(519),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(520),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(507),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(501),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(499),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(502),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    class: {
      'is-not-valid': _vm.errors.any(), 'is-dirty': _vm.value
    },
    attrs: {
      "id": 'label_' + _vm.id
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validate),
      expression: "validate"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": _vm.id,
      "type": "password",
      "tabindex": _vm.tabindex,
      "data-vv-name": _vm.label,
      "vv-data-path": "value"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.any()),
      expression: "errors.any()"
    }],
    staticClass: "mdl-tooltip mdl-tooltip--top mdl-tooltip--large error",
    attrs: {
      "data-mdl-for": 'label_' + _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorMsg)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "dropdown is-right",
    class: {
      'is-active': _vm.show_dropdown
    },
    attrs: {
      "id": "client-list"
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger",
    on: {
      "click": function($event) {
        _vm.show_dropdown = !_vm.show_dropdown
      }
    }
  }, [_c('span', {
    staticClass: "mdl-chip mdl-chip--deletable"
  }, [_c('span', {
    staticClass: "mdl-chip__text"
  }, [(_vm.selected_client.id) ? _c('span', [_vm._v(_vm._s(_vm.selected_client.id) + "  ")]) : _c('span', [_vm._v("Ny klient  ")])]), _c('span', {
    staticClass: "mdl-chip__action"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_dropdown),
      expression: "!show_dropdown"
    }],
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_down")]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_dropdown),
      expression: "show_dropdown"
    }],
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_up")])])])]), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('div', {
    staticClass: "dropdown-item menu-label",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Aktiva - " + _vm._s(_vm.active_list.length) + " st")]), _vm._l((_vm.active_list), function(client, index) {
    return _c('a', {
      key: client.uid,
      staticClass: "dropdown-item",
      class: {
        'is-active': _vm.selected_client.uid == client.uid
      },
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.select(client)
        }
      }
    }, [_vm._v(_vm._s(client.id))])
  }), _c('hr', {
    staticClass: "dropdown-divider"
  }), _c('a', {
    staticClass: "dropdown-item menu-label"
  }, [_vm._v("Avslutade")]), _vm._l((_vm.unactive_list), function(clients, year) {
    return _c('div', {
      key: year
    }, [_c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.clickYear(year)
        }
      }
    }, [_vm._v(_vm._s(year) + " - " + _vm._s(clients.length) + " st  "), _c('span', {
      staticClass: "icon toggle",
      class: {
        down: _vm.show_year == year
      }
    }, [_vm._v("▸")])]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show_year == year),
        expression: "show_year == year"
      }],
      staticStyle: {
        "margin-left": "1em"
      }
    }, _vm._l((clients), function(client) {
      return _c('a', {
        staticClass: "dropdown-item",
        class: {
          'is-active': _vm.selected_client.uid == client.uid
        },
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            _vm.select(client)
          }
        }
      }, [_vm._v(_vm._s(client.id))])
    }))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-snackbar mdl-js-snackbar"
  }, [_c('div', {
    staticClass: "mdl-snackbar__text"
  }), _c('button', {
    staticClass: "mdl-snackbar__action",
    attrs: {
      "type": "button"
    }
  })])
}]}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.values), function(val, idx) {
    return _c('v-radiobutton', {
      key: _vm.id + '_' + idx,
      attrs: {
        "id": _vm.id + '_' + idx,
        "label": _vm.labels[idx],
        "val": val,
        "name": _vm.name,
        "value": _vm.value
      },
      on: {
        "input": _vm.onInput
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-icon-toggle-button', {
    attrs: {
      "disabled": _vm.options.length == 0
    },
    on: {
      "clicked": function($event) {
        _vm.show = !_vm.show
      }
    }
  }), _vm._v(_vm._s(_vm.label)), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "mdl-list"
  }, _vm._l((_vm.options), function(option) {
    return _c('li', {
      key: option.uid,
      staticClass: "mdl-list__item"
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_vm._v(_vm._s(option.value))])])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Åldersintervall")]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Från")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Till")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": _vm.saveRanges
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")])])])])]), (_vm.age_ranges) ? _c('tbody', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable.tr",
      value: (_vm.reorderRanges),
      expression: "reorderRanges",
      modifiers: {
        "tr": true
      }
    }]
  }, _vm._l((_vm.age_ranges.value), function(interval, idx) {
    return _c('tr', {
      key: idx,
      attrs: {
        "data-id": idx
      }
    }, [_vm._m(0, true, false), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (interval[0]),
        expression: "interval[0]"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (interval[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(interval, 0, $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (interval[1]),
        expression: "interval[1]"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (interval[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(interval, 1, $event.target.value)
        }
      }
    })]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteRange(idx)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])])
  })) : _vm._e(), _c('tfoot', [_c('tr', [_c('td'), _c('td'), _c('td'), _c('td', [_c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": _vm.addRange
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v(_vm._s(_vm.label))]), _vm._l((_vm.options), function(option) {
    return _c('dd', {
      ref: "dd",
      refInFor: true
    }, [_c('label', {
      ref: "cbox_label",
      refInFor: true,
      staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
      attrs: {
        "for": 'id_' + option.value
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.option_values),
        expression: "option_values"
      }],
      staticClass: "mdl-checkbox__input",
      attrs: {
        "id": 'id_' + option.value,
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.option_values) ? _vm._i(_vm.option_values, option.value) > -1 : (_vm.option_values)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.option_values,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.option_values = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.option_values = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.option_values = $$c
          }
        }, _vm.onChange]
      }
    }), _c('span', {
      staticClass: "mdl-checkbox__label",
      domProps: {
        "innerHTML": _vm._s(option.value)
      }
    })])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "select",
    staticClass: "mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }, _vm._l((_vm.options), function(option, idx) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  })), _vm._m(0, false, false), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])])
}]}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Ändra egenskapsgrupp")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "GroupName",
      "label": "Namn"
    },
    model: {
      value: (_vm.g.name),
      callback: function($$v) {
        _vm.$set(_vm.g, "name", $$v)
      },
      expression: "g.name"
    }
  })], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    on: {
      "message": _vm.showMessage
    }
  }), _c('v-snackbar', {
    attrs: {
      "message": _vm.message
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "for": "new_type"
    }
  }, [_vm._v("Ny aktivitetsstyp:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_type.name),
      expression: "new_type.name"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": "new_type",
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_type.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_type, "name", $event.target.value)
      }
    }
  }), _c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": function($event) {
        _vm.addType()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])]), _c('ul', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable.li",
      value: (_vm.reorderTypes),
      expression: "reorderTypes",
      modifiers: {
        "li": true
      }
    }]
  }, _vm._l((_vm.activity_types.getEmbeds('activity_type')), function(type, idx) {
    return _c('li', {
      key: idx,
      staticClass: "mdl-list__item",
      attrs: {
        "id": type.uid,
        "data-order": idx
      }
    }, [_vm._m(0, true, false), (_vm.edit_uid != type.uid) ? _c('span', {
      staticClass: "mdl-textfield__input",
      on: {
        "click": function($event) {
          _vm.doEdit(type)
        }
      }
    }, [_vm._v(_vm._s(type.name))]) : _vm._e(), (_vm.edit_uid == type.uid) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edit_type.name),
        expression: "edit_type.name"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "maxlength": "36",
        "type": "text"
      },
      domProps: {
        "value": (_vm.edit_type.name)
      },
      on: {
        "change": function($event) {
          _vm.updateType(_vm.edit_type)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.edit_type, "name", $event.target.value)
        }
      }
    }) : _vm._e(), _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteType(type)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])
  })), _c('v-dialog-confirm', {
    attrs: {
      "id": "confirm",
      "message": _vm.show.message
    },
    on: {
      "ok": function($event) {
        _vm.show.action()
      },
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])
}]}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "mdl-card__supporting__text"
  }, [_c('div', {
    staticClass: "interval-wrapper"
  }, [_c('h5', {
    staticClass: "interval"
  }, [_vm._v("Intervall: "), _c('v-datefield', {
    attrs: {
      "id": "start",
      "label": "Start",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _c('v-datefield', {
    attrs: {
      "id": "end",
      "label": "Slut",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)]), _c('form', {
    staticClass: "gridform",
    attrs: {
      "id": "new_activity"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Ny aktivitet")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "ActivityName",
      "label": "Namn",
      "validate": "required"
    },
    model: {
      value: (_vm.new_activity.name),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "name", $$v)
      },
      expression: "new_activity.name"
    }
  })], 1), _c('div', {
    staticClass: "cell"
  }, [_c('v-selectfield', {
    attrs: {
      "id": "type",
      "label": "Typ",
      "options": _vm.types
    },
    model: {
      value: (_vm.new_activity.activity_type_uid),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "activity_type_uid", $$v)
      },
      expression: "new_activity.activity_type_uid"
    }
  })], 1), _c('div', {
    staticClass: "cell date"
  }, [_c('v-datefield', {
    attrs: {
      "id": "new_start",
      "label": "Start",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.new_activity.start),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "start", $$v)
      },
      expression: "new_activity.start"
    }
  })], 1), _c('div', {
    staticClass: "cell date"
  }, [_c('v-datefield', {
    attrs: {
      "id": "new_end",
      "label": "Slut",
      "validate": 'date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.new_activity.end),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "end", $$v)
      },
      expression: "new_activity.end"
    }
  })], 1), _c('div', {
    staticClass: "cell tools"
  }, [_c('v-fab-button', {
    attrs: {
      "id": "save_button",
      "icon": "save"
    },
    on: {
      "clicked": _vm.addActivity
    }
  })], 1)])])])])]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', [_vm._v("Aktiviteter"), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('name'),
    on: {
      "click": function($event) {
        _vm.sort('name')
      }
    }
  }, [_vm._v("Aktivitet")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('activity_type_label'),
    on: {
      "click": function($event) {
        _vm.sort('activity_type_label')
      }
    }
  }, [_vm._v("Typ")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Start")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Slut")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Ändra/radera")])])]), (_vm.are_loaded.activities) ? _c('tbody', _vm._l((_vm.sortedActivities(_vm.sort_key)), function(activity, idx) {
    return _c('tr', {
      key: idx,
      attrs: {
        "id": activity.uid,
        "data-order": idx
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.name))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-textfield', {
      attrs: {
        "id": "name",
        "name": "ActivityName",
        "label": "Namn",
        "validate": "required"
      },
      model: {
        value: (_vm.edit_activity.name),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "name", $$v)
        },
        expression: "edit_activity.name"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.activity_type_label))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-selectfield', {
      attrs: {
        "id": "type",
        "label": "Typ",
        "options": _vm.types
      },
      model: {
        value: (_vm.edit_activity.activity_type_uid),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "activity_type_uid", $$v)
        },
        expression: "edit_activity.activity_type_uid"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.start))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-datefield', {
      attrs: {
        "id": "edit_start",
        "label": "Start",
        "validate": 'date_format:YYYY-MM-DD'
      },
      model: {
        value: (_vm.edit_activity.start),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "start", $$v)
        },
        expression: "edit_activity.start"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.end))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-datefield', {
      attrs: {
        "id": "edit_end",
        "label": "Slut",
        "validate": 'date_format:YYYY-MM-DD'
      },
      model: {
        value: (_vm.edit_activity.end),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "end", $$v)
        },
        expression: "edit_activity.end"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteActivity(activity)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])]), (_vm.edit_uid != activity.uid) ? _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.editActivity(activity)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("edit")])]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.updateActivity()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("save")])]) : _vm._e()])])
  })) : _vm._e()]), _c('v-dialog-confirm', {
    attrs: {
      "id": "confirm",
      "message": _vm.show.message
    },
    on: {
      "ok": function($event) {
        _vm.show.action()
      },
      "cancel": _vm.cancel
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('div', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Aktiviteter")])])
}]}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label date",
    class: {
      'is-not-valid': _vm.errors.any(), 'is-dirty': _vm.value
    },
    attrs: {
      "id": 'label_' + _vm.id
    }
  }, [_c('v-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validate),
      expression: "validate"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": _vm.id,
      "value": _vm.value,
      "data-vv-name": _vm.label,
      "data-vv-value-path": "value"
    },
    on: {
      "input": _vm.onInput
    }
  }), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.any()),
      expression: "errors.any()"
    }],
    staticClass: "mdl-tooltip mdl-tooltip--top mdl-tooltip--large error",
    attrs: {
      "data-mdl-for": 'label_' + _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorMsg)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    class: {
      'is-dirty': _vm.value, 'is-invalid': _vm.isInvalid
    },
    attrs: {
      "id": 'label_' + _vm.id
    }
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": _vm.id,
      "type": "text",
      "tabindex": _vm.tabindex
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput,
      "blur": _vm.onInput
    }
  }), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.errorMsg))])])])
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    staticClass: "mdl-dialog"
  }, [_c('h4', {
    staticClass: "mdl-dialog__title"
  }, [_vm._t("title")], 2), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_vm._t("content")], 2), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_vm._t("buttons", [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.$el.close(true)
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$el.close(false)
      }
    }
  }, [_vm._v("Avbryt")])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable.li",
      value: (_vm.reorderGroup),
      expression: "reorderGroup",
      modifiers: {
        "li": true
      }
    }],
    staticClass: "mdlext-accordion mdlext-accordion--vertical",
    attrs: {
      "id": "groups"
    }
  }, [_vm._l((_vm.cprop_groups.getEmbeds('client_property_groups')), function(group, g_idx) {
    return _c('li', {
      key: group.uid,
      staticClass: "mdlext-accordion__panel",
      attrs: {
        "id": group.uid,
        "data-order": g_idx
      }
    }, [_c('header', {
      staticClass: "mdlext-accordion__tab"
    }, [_c('span', {
      staticClass: "mdlext-accordion__tab__caption"
    }, [_c('span', {
      staticClass: "button-group-fab"
    }, [_vm._m(0, true, false), _c('v-icon-toggle-button', {
      on: {
        "clicked": function($event) {
          _vm.toggleShowGroup(group.uid)
        }
      }
    })], 1), _c('span', [_vm._v(_vm._s(group.name))]), _c('span', {
      staticClass: "button-group-fab right"
    }, [_c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.editGroup(group)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("edit")])]), _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteGroup(group)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])])]), _c('section', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.toggle.groups[group.uid]),
        expression: "toggle.groups[group.uid]"
      }],
      staticClass: "mdlext-accordion__tabpanel"
    }, [_c('ul', {
      directives: [{
        name: "sortable",
        rawName: "v-sortable.li",
        value: (_vm.reorderProperty),
        expression: "reorderProperty",
        modifiers: {
          "li": true
        }
      }],
      staticStyle: {
        "list-style": "none"
      },
      attrs: {
        "id": 'properties_for_' + group.uid,
        "data-g_uid": group.uid
      }
    }, _vm._l((group.getEmbeds('client_property_definitions')), function(prop, p_idx) {
      return _c('li', {
        key: prop.uid,
        staticClass: "prop",
        attrs: {
          "id": 'property_' + prop.uid,
          "data-order": p_idx,
          "data-g_uid": group.uid,
          "data-p_uid": prop.uid
        }
      }, [_c('span', {
        staticClass: "button-group-fab"
      }, [_vm._m(1, true, false), _c('v-icon-toggle-button', {
        on: {
          "clicked": function($event) {
            _vm.toggleShowOptions(prop.uid)
          }
        }
      })], 1), _c('span', [_vm._v(_vm._s(prop.label))]), _c('span', {
        staticClass: "button-group-fab right"
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon",
        on: {
          "click": function($event) {
            _vm.editProperty(prop)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("edit")])]), _c('button', {
        staticClass: "mdl-button mdl-button--icon",
        on: {
          "click": function($event) {
            _vm.deleteProperty(prop)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("delete forever")])])]), _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.toggle.options[prop.uid]),
          expression: "toggle.options[prop.uid]"
        }, {
          name: "sortable",
          rawName: "v-sortable.li",
          value: (_vm.reorderOption),
          expression: "reorderOption",
          modifiers: {
            "li": true
          }
        }],
        staticStyle: {
          "list-style": "none"
        },
        attrs: {
          "id": 'options_for_' + prop.uid
        }
      }, _vm._l((prop.getEmbeds('client_property_option')), function(option, o_idx) {
        return _c('li', {
          key: option.uid,
          staticClass: "opt",
          attrs: {
            "id": 'option_' + option.uid,
            "data-order": o_idx,
            "data-g_uid": group.uid,
            "data-p_uid": prop.uid
          }
        }, [_vm._m(2, true, false), _c('span', [_vm._v(_vm._s(option.value))]), _c('span', {
          staticClass: "right"
        }, [_c('button', {
          staticClass: "mdl-button mdl-button--icon",
          on: {
            "click": function($event) {
              _vm.editOption(group, prop, option)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])]), _c('button', {
          staticClass: "mdl-button mdl-button--icon",
          on: {
            "click": function($event) {
              _vm.deleteOption(group, prop, option)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])])
      })), _c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon",
        attrs: {
          "onClick": "return false"
        },
        on: {
          "click": function($event) {
            _vm.addOption(group, prop)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("add")])])])
    })), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--icon",
      attrs: {
        "onClick": "return false"
      },
      on: {
        "click": function($event) {
          _vm.addProperty(group)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("add")])])])])
  }), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--icon",
    attrs: {
      "onClick": "return false"
    },
    on: {
      "click": function($event) {
        _vm.addGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2), _c('v-dialog-property-group-edit', {
    attrs: {
      "id": "edit_group",
      "group": _vm.edit_group
    },
    on: {
      "ok": function($event) {
        _vm.updateGroup($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-property-group-add', {
    attrs: {
      "id": "add_group"
    },
    on: {
      "ok": function($event) {
        _vm.newGroup($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-confirm', {
    attrs: {
      "id": "confirm",
      "message": _vm.show.message
    },
    on: {
      "ok": function($event) {
        _vm.show.action()
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-property-edit', {
    attrs: {
      "id": "edit_prop",
      "prop": _vm.edit_prop,
      "types": _vm.types
    },
    on: {
      "ok": function($event) {
        _vm.updateProperty($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-property-add', {
    attrs: {
      "id": "add_prop",
      "group": _vm.add_to_group,
      "types": _vm.types
    },
    on: {
      "ok": function($event) {
        _vm.newProperty($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-option-add', {
    attrs: {
      "id": "add_option",
      "prop": _vm.edit_prop,
      "group": _vm.edit_group
    },
    on: {
      "ok": function($event) {
        _vm.newOption($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-option-edit', {
    attrs: {
      "id": "edit_option",
      "prop": _vm.edit_prop,
      "group": _vm.edit_group,
      "option": _vm.edit_option
    },
    on: {
      "ok": function($event) {
        _vm.updateOption($event)
      },
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "button-group-fab"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])])
}]}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-js-ripple-effect",
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "onClick": "return false"
    },
    on: {
      "click": function($event) {
        _vm.clicked()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mdl-color-text--blue-grey-300"
  }, [_vm._v(_vm._s(_vm.icon))])])])
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "date",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    key: _vm.id,
    staticClass: "toggle",
    class: {
      down: _vm.toggle, disabled: _vm.disabled
    },
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "onClick": "return false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clicked()
      }
    }
  }, [_c('span', [_vm._v("▸")])])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    ref: _vm.label,
    staticClass: "mdl-data-table",
    attrs: {
      "id": _vm.label
    }
  }, [_c('caption', {
    staticClass: "tableexport-caption"
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v("Kön fördelat på ålder")]), _c('br'), _c('download-button', {
    attrs: {
      "table-ref": _vm.table,
      "filename": _vm.label + '_' + _vm.start + '--' + _vm.end + '_Kön_fördelat_på_ålder'
    }
  })], 1), _vm._m(0, false, false), _c('tbody', [_vm._l((_vm.age_ranges), function(range, idx) {
    return _c('tr', [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(range))]), _c('td', [_vm._v(_vm._s((_vm.cluster[idx].woman || []).length))]), _c('td', [_vm._v(_vm._s((_vm.cluster[idx].man || []).length))]), _c('td', [_vm._v(_vm._s((_vm.cluster[idx].hen || []).length))]), _c('td', {
      staticClass: "sum"
    }, [_vm._v(_vm._s((_vm.cluster[idx].man || []).length + (_vm.cluster[idx].hen || []).length + (_vm.cluster[idx].woman || []).length))])])
  }), _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric sum"
  }, [_vm._v("Summa")]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'woman')))]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'man')))]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'hen')))]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'man') + _vm.sumLengthByKey(_vm.cluster, 'woman') + _vm.sumLengthByKey(_vm.cluster, 'hen')))])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Åldersintervall")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Kvinnor")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Män")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Annat")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Totalt")])])])
}]}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    },
    on: {
      "open": function($event) {
        _vm.o.value = null
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Lägg till alternativ")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "value",
      "name": "OptionValue",
      "label": "Värde"
    },
    model: {
      value: (_vm.o.value),
      callback: function($$v) {
        _vm.$set(_vm.o, "value", $$v)
      },
      expression: "o.value"
    }
  })], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    },
    on: {
      "open": _vm.reset
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Ny egenskap")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "label",
      "name": "PropertyLabel",
      "label": "Etikett",
      "validate": "required|max: 16"
    },
    on: {
      "errors": function($event) {
        _vm.showErrors($event)
      }
    },
    model: {
      value: (_vm.p.label),
      callback: function($$v) {
        _vm.$set(_vm.p, "label", $$v)
      },
      expression: "p.label"
    }
  }), _c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "PropertyName",
      "label": "Namn",
      "validate": "required"
    },
    on: {
      "errors": function($event) {
        _vm.showErrors($event)
      }
    },
    model: {
      value: (_vm.p.name),
      callback: function($$v) {
        _vm.$set(_vm.p, "name", $$v)
      },
      expression: "p.name"
    }
  }), _c('v-textfield', {
    attrs: {
      "id": "description",
      "name": "description",
      "label": "Beskrivning"
    },
    model: {
      value: (_vm.p.description),
      callback: function($$v) {
        _vm.$set(_vm.p, "description", $$v)
      },
      expression: "p.description"
    }
  }), _c('v-checkbox', {
    attrs: {
      "id": "is_active",
      "label": "Är aktiv"
    },
    on: {
      "change": function($event) {
        _vm.set('is_active', arguments[0])
      }
    },
    model: {
      value: (_vm.p.is_active),
      callback: function($$v) {
        _vm.$set(_vm.p, "is_active", $$v)
      },
      expression: "p.is_active"
    }
  }), _c('v-selectfield', {
    attrs: {
      "id": "type",
      "label": "Datatyp",
      "options": _vm.types
    },
    model: {
      value: (_vm.p.type),
      callback: function($$v) {
        _vm.$set(_vm.p, "type", $$v)
      },
      expression: "p.type"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_error),
      expression: "show_error"
    }]
  }, [_c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(" " + _vm._s(error))])
  }))])], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v(_vm._s(_vm.title)), _c('br'), _vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))]), _c('div', {
    attrs: {
      "id": _vm.id + '_chart'
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__drawer posit-drawer"
  }, [_c('header', {
    staticClass: "posit-drawer-header",
    staticStyle: {}
  }, [_c('img', {
    staticClass: "posit-avatar",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": "/static/images/owl3.png"
    }
  }), _c('div', {
    staticClass: "posit-avatar-dropdown"
  }, [_c('span', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _c('nav', {
    staticClass: "posit-navigation mdl-navigation mdl-color--blue-grey-800"
  }, [_c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "start"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("assignment")]), _vm._v("Registrering")]), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "activities"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("event")]), _vm._v("Aktiviteter")]), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "statistics"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("pie_chart")]), _vm._v("Statistik        ")]), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "administration"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("settings")]), _vm._v("Administration")]), _c('div', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("power_settings_new")]), _vm._v("Logga ut")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "id": "statistics"
    }
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "mdl-card__supporting__text"
  }, [(_vm.data_is_loaded) ? _c('div', [_c('div', {
    staticClass: "interval-wrapper"
  }, [_c('h5', {
    staticClass: "interval"
  }, [_vm._v("Intervall: "), _c('v-datefield', {
    attrs: {
      "id": "start",
      "label": "Start",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _c('v-datefield', {
    attrs: {
      "id": "end",
      "label": "Slut",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)]), _c('div', {
    staticClass: "table-and-chart-wrapper"
  }, [_c('div', {
    staticClass: "table-and-chart"
  }, [_c('v-statisticstable-full', {
    attrs: {
      "id": "active_table",
      "label": "Aktiva i perioden",
      "start": _vm.start,
      "end": _vm.end,
      "age_ranges": _vm.age_ranges_strings,
      "cluster": _vm.clients_by_status_and_age.active
    }
  }), _c('div', {
    staticClass: "hr"
  }), _c('v-barchart', {
    attrs: {
      "id": "active",
      "title": "Aktiva i perioden",
      "start": _vm.start,
      "end": _vm.end,
      "data": _vm.clients_by_status_and_age.active,
      "data-labels": ['Kvinna', 'Man', 'Annat'],
      "x-axis-categories": _vm.age_ranges_strings,
      "x-axis-label": "Åldersgrupper",
      "y-axis-label": "Antal klienter"
    }
  })], 1), _c('div', {
    staticClass: "table-and-chart"
  }, [_c('v-statisticstable-full', {
    attrs: {
      "id": "new_table",
      "label": "Nya i perioden",
      "start": _vm.start,
      "end": _vm.end,
      "age_ranges": _vm.age_ranges_strings,
      "cluster": _vm.clients_by_status_and_age.new
    }
  }), _c('div', {
    staticClass: "hr"
  }), _c('v-barchart', {
    attrs: {
      "id": "new",
      "title": "Nya i perioden",
      "start": _vm.start,
      "end": _vm.end,
      "data": _vm.clients_by_status_and_age.new,
      "data-labels": ['Kvinna', 'Man', 'Annat'],
      "x-axis-categories": _vm.age_ranges_strings,
      "x-axis-label": "Åldersgrupper",
      "y-axis-label": "Antal klienter"
    }
  })], 1), _c('div', {
    staticClass: "table-and-chart"
  }, [_c('v-statisticstable-full', {
    attrs: {
      "id": "closed_table",
      "label": "Avslutade i perioden",
      "start": _vm.start,
      "end": _vm.end,
      "age_ranges": _vm.age_ranges_strings,
      "cluster": _vm.clients_by_status_and_age.closed
    }
  }), _c('div', {
    staticClass: "hr"
  }), _c('v-barchart', {
    attrs: {
      "id": "closed",
      "title": "Avslutade i perioden",
      "start": _vm.start,
      "end": _vm.end,
      "data": _vm.clients_by_status_and_age.closed,
      "data-labels": ['Kvinna', 'Man', 'Annat'],
      "x-axis-categories": _vm.age_ranges_strings,
      "x-axis-label": "Åldersgrupper",
      "y-axis-label": "Antal klienter"
    }
  })], 1)]), _vm._l((_vm.clients_by_status_and_age.by_property), function(group) {
    return _c('div', [_c('table', {
      ref: group.label,
      refInFor: true,
      staticClass: "mdl-data-table",
      attrs: {
        "id": group.label
      }
    }, [_c('caption', {
      staticClass: "tableexport-caption"
    }, [_c('b', [_vm._v(_vm._s(group.label))]), _vm._v(" fördelat på kön"), _c('br'), _c('span', {
      staticClass: "sub_caption"
    }, [_vm._v("Aktiva i perioden " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end))]), _c('br'), _c('download-button', {
      attrs: {
        "table-ref": _vm.getTableRef(group.label),
        "filename": group.label + '_' + _vm.start + '--' + _vm.end + '_Kön_fördelat_på_ålder'
      }
    })], 1), _vm._m(1, true, false), _c('tbody', _vm._l((group.properties), function(property) {
      return _c('tr', [_c('td', {
        staticClass: "mdl-data-table__cell--non-numeric"
      }, [_vm._v(_vm._s(property.label))]), _c('td', [_vm._v(_vm._s((property.woman || []).length))]), _c('td', [_vm._v(_vm._s((property.man || []).length))]), _c('td', [_vm._v(_vm._s((property.hen || []).length))]), _c('td', {
        staticClass: "sum"
      }, [_vm._v(_vm._s((property.man || []).length + (property.hen || []).length + (property.woman || []).length))])])
    }))])])
  }), _c('table', {
    ref: "Aktiviteter",
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp",
    attrs: {
      "id": "Aktiviteter"
    }
  }, [_c('caption', {
    staticClass: "tableexport-caption"
  }, [_vm._v("Aktiviteter " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end)), _c('br'), _c('download-button', {
    attrs: {
      "table-ref": _vm.getTableRef('Aktiviteter'),
      "filename": 'Aktiviteter_' + _vm.start + '--' + _vm.end + '_Kön_fördelat_på_ålder'
    }
  })], 1), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('name'),
    on: {
      "click": function($event) {
        _vm.sort('name')
      }
    }
  }, [_vm._v("Aktivitet")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('activity_type_label'),
    on: {
      "click": function($event) {
        _vm.sort('activity_type_label')
      }
    }
  }, [_vm._v("Typ")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Start")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Slut")])])]), (_vm.are_loaded.activities) ? _c('tbody', _vm._l((_vm.sortedActivities(_vm.sort_key)), function(activity, idx) {
    return _c('tr', {
      key: idx,
      attrs: {
        "id": activity.uid,
        "data-order": idx
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(activity.name))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(activity.activity_type_label))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(activity.start))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(activity.end))])])
  })) : _vm._e()])], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('div', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Statistik")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Typ")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Kvinnor")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Män")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Annat")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Totalt")])])])
}]}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.message))]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    class: {
      'is-dirty': _vm.value
    }
  }, [_c('textarea', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": _vm.id,
      "rows": _vm.rows
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posit-layout mdl-layout mdl-js-layout mdl-layout--fixed-drawer mdl-layout--fixed-header"
  }, [_c('header', {
    staticClass: "posit-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("POSTAT")]), _c('span', {
    staticClass: "version"
  }, [_vm._v("@" + _vm._s(_vm.version) + " - v" + _vm._s(_vm.api_version))]), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _c('div', {
    staticClass: "mdl-layout-title",
    attrs: {
      "id": "insert_into_header"
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  })]), _c('menu-drawer'), _c('main', {
    staticClass: "mdl-layout__content mdl-color--grey-50",
    attrs: {
      "id": "main"
    }
  }, [_c('router-view', {
    on: {
      "message": function($event) {
        _vm.$emit('message', $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "name": "client_form",
      "hook": "formHook",
      "id": "client-form"
    }
  }, [_c('span', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom:insert_into_header",
      arg: "insert_into_header"
    }]
  }, [_c('div', {
    staticClass: "select-client"
  }, [_c('v-client-list')], 1)]), _c('div', {
    staticClass: "mdl-card__supporting__text"
  }, [_c('div', {
    staticClass: "mdl-tabs mdl-js-tabs mdl-js-ripple-effect"
  }, [_c('div', {
    staticClass: "mdl-tabs__tab-bar"
  }, [_c('a', {
    ref: "first_tab",
    staticClass: "mdl-tabs__tab is-active",
    attrs: {
      "href": "#general"
    }
  }, [_vm._v("Allmänt")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#properties"
    }
  }, [_vm._v("Uppgifter")])]), _c('div', {
    staticClass: "mdl-tabs__panel is-active",
    attrs: {
      "id": "general"
    }
  }, [_c('div', {
    staticClass: "gridform"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Allmänt")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-textfield', {
    attrs: {
      "id": "client_id",
      "name": "KlientID",
      "label": "Klientkod",
      "is-invalid": _vm.id_is_invalid,
      "error-msg": "Klientkoden är upptagen"
    },
    model: {
      value: (_vm.client.id),
      callback: function($$v) {
        _vm.$set(_vm.client, "id", $$v)
      },
      expression: "client.id"
    }
  })], 1), _c('div', {
    staticClass: "cell"
  }, [_c('v-textfield', {
    attrs: {
      "id": "client_year",
      "label": "Födelseår",
      "is-invalid": _vm.year_is_invalid,
      "error-msg": 'Året skall vara en siffra mellan ' + _vm.min_year + ' och ' + _vm.max_year
    },
    on: {
      "input": _vm.checkYear
    },
    model: {
      value: (_vm.client.year),
      callback: function($$v) {
        _vm.$set(_vm.client, "year", $$v)
      },
      expression: "client.year"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Kön")]), _c('v-radiobutton-group', {
    attrs: {
      "id": "gender",
      "labels": ['Kvinna', 'Man', 'Annat'],
      "values": ['woman', 'man', 'hen'],
      "name": "gender"
    },
    model: {
      value: (_vm.client.gender),
      callback: function($$v) {
        _vm.$set(_vm.client, "gender", $$v)
      },
      expression: "client.gender"
    }
  })], 1)])])])]), _c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Status")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-datefield', {
    attrs: {
      "id": "client_start",
      "label": "Aktiv",
      "validate": "date_format:YYYY-MM-DD"
    },
    model: {
      value: (_vm.client.start),
      callback: function($$v) {
        _vm.$set(_vm.client, "start", $$v)
      },
      expression: "client.start"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-datefield', {
    attrs: {
      "id": "client_end",
      "label": "Avslutad",
      "validate": "date_format:YYYY-MM-DD"
    },
    model: {
      value: (_vm.client.end),
      callback: function($$v) {
        _vm.$set(_vm.client, "end", $$v)
      },
      expression: "client.end"
    }
  })], 1)])])])])])]), _c('div', {
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "properties"
    }
  }, [_c('div', {
    staticClass: "gridform"
  }, _vm._l((_vm.groups.getEmbeds('client_property_groups')), function(group) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(group.name))]), _vm._l((group.getEmbeds('client_property_definitions')), function(cprop) {
      return _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "cell",
        attrs: {
          "id": 'cell_' + cprop.name
        }
      }, [(cprop.type == 'STRING') ? _c('v-textfield', {
        attrs: {
          "id": 'cprop_' + cprop.name,
          "label": cprop.label
        },
        model: {
          value: (_vm.props[cprop.uid]),
          callback: function($$v) {
            _vm.$set(_vm.props, cprop.uid, $$v)
          },
          expression: "props[cprop.uid]"
        }
      }) : _vm._e(), (cprop.type == 'BOOLEAN') ? _c('v-checkbox', {
        attrs: {
          "id": 'cprop_' + cprop.name,
          "label": cprop.label,
          "value": _vm.getPropertyValue(cprop.uid)
        },
        on: {
          "change": function($event) {
            _vm.setPropertyValue(cprop.uid, arguments[0])
          }
        }
      }) : _vm._e(), (cprop.type == 'ARRAY') ? _c('v-multi_checkbox', {
        attrs: {
          "options": cprop.getEmbeds('client_property_option'),
          "label": cprop.label,
          "value": _vm.getPropertyValue(cprop.uid)
        },
        on: {
          "change": function($event) {
            _vm.setPropertyValue(cprop.uid, arguments[0])
          }
        }
      }) : _vm._e()], 1), (cprop.description) ? _c('span', {
        staticClass: "mdl-tooltip",
        attrs: {
          "data-mdl-for": 'cprop_' + cprop.name
        }
      }, [_vm._v(_vm._s(cprop.description))]) : _vm._e()])
    })], 2)])])
  }))])]), _c('footer', {
    attrs: {
      "id": "footer-color-text--grey-600"
    }
  }, [_c('div', {
    staticClass: "button-group-fab"
  }, [_c('v-fab-button', {
    attrs: {
      "id": "new_button",
      "icon": "add"
    },
    on: {
      "clicked": function($event) {
        _vm.newClient()
      }
    }
  }), _c('v-fab-button', {
    attrs: {
      "id": "save_button",
      "icon": "save"
    },
    on: {
      "clicked": function($event) {
        _vm.saveClient(_vm.client)
      }
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-radio mdl-js-radio-mdl-js-ripple-effect",
    class: {
      'is-dirty': _vm.value, 'error': _vm.errors.any()
    },
    attrs: {
      "for": _vm.id
    }
  }, [_c('input', {
    staticClass: "mdl-radio_button",
    attrs: {
      "id": _vm.id,
      "type": "radio",
      "name": _vm.name,
      "data-vv-name": _vm.name,
      "data-vv-value-path": "value"
    },
    domProps: {
      "value": _vm.val,
      "checked": _vm.value === _vm.val
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mdl-spinner mdl-js-spinner",
    class: {
      'is-active': _vm.is_active
    }
  })
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    ref: "toolbar"
  }), _c('div', {
    ref: "editor"
  })])
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": _vm.id
    }
  }, [_c('input', {
    ref: "cbox",
    staticClass: "mdl-checkbox__input",
    attrs: {
      "id": _vm.id,
      "type": "checkbox",
      "name": _vm.id
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card",
    class: {
      shake: _vm.error
    },
    attrs: {
      "id": "login"
    }
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "name": "login_form"
    }
  }, [_c('v-textfield', {
    attrs: {
      "id": "username",
      "name": "username",
      "label": "Användarnamn",
      "tabindex": "1",
      "data-vv-value-path": "username",
      "validate": "required"
    },
    on: {
      "errors": _vm.onError
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _c('v-password', {
    attrs: {
      "id": "password",
      "name": "password",
      "tabindex": "2",
      "label": "Lösenord",
      "validate": "required"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)]), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit",
      "tabindex": "3"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Logga in")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-color-text--white"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("POSTAT")])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": _vm.id
    }
  }, [_c('input', {
    ref: "cbox",
    staticClass: "mdl-switch__input",
    attrs: {
      "id": _vm.id,
      "type": "checkbox",
      "name": _vm.id
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('span', {
    staticClass: "mdl-switch__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Ändra alternativ")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "value",
      "name": "OptionValue",
      "label": "Värde"
    },
    model: {
      value: (_vm.o.value),
      callback: function($$v) {
        _vm.$set(_vm.o, "value", $$v)
      },
      expression: "o.value"
    }
  })], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "id": "client-form"
    }
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "mdl-card__supporting__text"
  }, [_c('div', {
    ref: "tabs",
    staticClass: "mdl-tabs mdl-js-tabs mdl-js-ripple-effect"
  }, [_vm._m(1, false, false), _c('div', {
    ref: "properties",
    staticClass: "mdl-tabs__panel is-active",
    attrs: {
      "id": "properties"
    }
  }, [_c('v-properties')], 1), _c('div', {
    ref: "statistics",
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "statistics"
    }
  }, [_c('div', {
    staticClass: "mdl-card"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('v-statistics')], 1)])]), _c('div', {
    ref: "activities",
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "activities"
    }
  }, [_c('v-activities')], 1), _c('div', {
    ref: "table",
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "tables"
    }
  }, [_c('v-table')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('div', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Administration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-tabs__tab-bar"
  }, [_c('a', {
    staticClass: "mdl-tabs__tab is-active",
    attrs: {
      "href": "#properties"
    }
  }, [_vm._v("Klientuppgifter")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#statistics"
    }
  }, [_vm._v("Statistik")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#activities"
    }
  }, [_vm._v("Aktiviteter")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#tables"
    }
  }, [_vm._v("Tabell")])])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Ändra egenskap")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "label",
      "name": "PropertyLabel",
      "label": "Etikett"
    },
    model: {
      value: (_vm.p.label),
      callback: function($$v) {
        _vm.$set(_vm.p, "label", $$v)
      },
      expression: "p.label"
    }
  }), _c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "PropertyName",
      "label": "Namn"
    },
    model: {
      value: (_vm.p.name),
      callback: function($$v) {
        _vm.$set(_vm.p, "name", $$v)
      },
      expression: "p.name"
    }
  }), _c('v-textfield', {
    attrs: {
      "id": "description",
      "name": "description",
      "label": "Beskrivning"
    },
    model: {
      value: (_vm.p.description),
      callback: function($$v) {
        _vm.$set(_vm.p, "description", $$v)
      },
      expression: "p.description"
    }
  }), _c('v-checkbox', {
    attrs: {
      "id": "is_active",
      "label": "Är aktiv"
    },
    on: {
      "change": function($event) {
        _vm.set('is_active', arguments[0])
      }
    },
    model: {
      value: (_vm.p.is_active),
      callback: function($$v) {
        _vm.$set(_vm.p, "is_active", $$v)
      },
      expression: "p.is_active"
    }
  }), _c('v-selectfield', {
    attrs: {
      "id": "type",
      "label": "Datatyp",
      "options": _vm.types
    },
    model: {
      value: (_vm.p.type),
      callback: function($$v) {
        _vm.$set(_vm.p, "type", $$v)
      },
      expression: "p.type"
    }
  })], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "interval-wrapper"
  }, [_c('h5', {
    staticClass: "interval"
  }, [_vm._v("Intervall: "), _c('v-datefield', {
    attrs: {
      "id": "start",
      "label": "Start",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _c('v-datefield', {
    attrs: {
      "id": "end",
      "label": "Slut",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Aktiva klienter  - " + _vm._s(_vm.clients_by_status.active.length) + " st "), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('id'),
    on: {
      "click": function($event) {
        _vm.sort('id')
      }
    }
  }, [_vm._v("Id")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('uid'),
    on: {
      "click": function($event) {
        _vm.sort('uid')
      }
    }
  }, [_vm._v("Uid")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('gender'),
    on: {
      "click": function($event) {
        _vm.sort('gender')
      }
    }
  }, [_vm._v("Kön")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('year'),
    on: {
      "click": function($event) {
        _vm.sort('year')
      }
    }
  }, [_vm._v("Födelseår")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Aktiv")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Avslutad")])])]), _c('tbody', _vm._l((_vm.sortedTable(_vm.clients_by_status.active)), function(client) {
    return _c('tr', {
      key: client.uid,
      attrs: {
        "data-id": client.uid
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.id))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.uid))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.gender))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.year))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.start))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.end))])])
  }))]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Avslutade klienter - " + _vm._s(_vm.clients_by_status.closed.length) + " st "), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('id'),
    on: {
      "click": function($event) {
        _vm.sort('id')
      }
    }
  }, [_vm._v("Id")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('uid'),
    on: {
      "click": function($event) {
        _vm.sort('uid')
      }
    }
  }, [_vm._v("Uid")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('gender'),
    on: {
      "click": function($event) {
        _vm.sort('gender')
      }
    }
  }, [_vm._v("Kön")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('year'),
    on: {
      "click": function($event) {
        _vm.sort('year')
      }
    }
  }, [_vm._v("Födelseår")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Aktiv")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Avslutad")])])]), _c('tbody', _vm._l((_vm.sortedTable(_vm.clients_by_status.closed)), function(client) {
    return _c('tr', {
      key: client.uid,
      attrs: {
        "data-id": client.uid
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.id))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.uid))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.gender))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.year))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.start))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.end))])])
  }))]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Nya klienter - " + _vm._s(_vm.clients_by_status.new.length) + " st "), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('id'),
    on: {
      "click": function($event) {
        _vm.sort('id')
      }
    }
  }, [_vm._v("Id")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('uid'),
    on: {
      "click": function($event) {
        _vm.sort('uid')
      }
    }
  }, [_vm._v("Uid")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('gender'),
    on: {
      "click": function($event) {
        _vm.sort('gender')
      }
    }
  }, [_vm._v("Kön")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('year'),
    on: {
      "click": function($event) {
        _vm.sort('year')
      }
    }
  }, [_vm._v("Födelseår")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Aktiv")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Avslutad")])])]), _c('tbody', _vm._l((_vm.sortedTable(_vm.clients_by_status.new)), function(client) {
    return _c('tr', {
      key: client.uid,
      attrs: {
        "data-id": client.uid
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.id))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.uid))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.gender))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.year))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.start))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.end))])])
  }))]), _vm._l((_vm.clients_by_status_and_age.by_property), function(group) {
    return _c('div', [_c('table', {
      ref: group.label,
      refInFor: true,
      staticClass: "mdl-data-table",
      attrs: {
        "id": group.label
      }
    }, [_c('caption', {
      staticClass: "tableexport-caption"
    }, [_c('b', [_vm._v(_vm._s(group.label))]), _vm._v(" fördelat på kön"), _c('br'), _c('span', {
      staticClass: "sub_caption"
    }, [_vm._v("Aktiva i perioden " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _vm._m(0, true, false), _c('tbody', _vm._l((group.properties), function(property) {
      return _c('tr', [_c('td', {
        staticClass: "mdl-data-table__cell--non-numeric"
      }, [_vm._v(_vm._s(property.label))]), _c('td', {
        staticClass: "mdl-data-table__cell--non-numeric",
        domProps: {
          "innerHTML": _vm._s(_vm.joinArray(property.man, 'id'))
        }
      }), _c('td', {
        staticClass: "mdl-data-table__cell--non-numeric",
        domProps: {
          "innerHTML": _vm._s(_vm.joinArray(property.woman, 'id'))
        }
      }), _c('td', {
        staticClass: "mdl-data-table__cell--non-numeric",
        domProps: {
          "innerHTML": _vm._s(_vm.joinArray(property.hen, 'id'))
        }
      }), _c('td', {
        staticClass: "sum"
      }, [_vm._v(_vm._s((property.man || []).length + (property.hen || []).length + (property.woman || []).length))])])
    }))])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Typ")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Män")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Kvinnor")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Annat")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Totalt")])])])
}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    },
    on: {
      "open": function($event) {
        _vm.g.name = null
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Lägg till egenskapsgrupp")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "GroupName",
      "label": "Namn"
    },
    model: {
      value: (_vm.g.name),
      callback: function($$v) {
        _vm.$set(_vm.g, "name", $$v)
      },
      expression: "g.name"
    }
  })], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}

/***/ }),
/* 540 */,
/* 541 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 542 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[293]);


// WEBPACK FOOTER //
// static/js/app.a1bcd2a24c05f48cb5f3.js